export default {
	one: "一",
	two: "二",
	three: "三",
	four: "四",
	five: "五",
	six: "六",
	seven: "七",
	eight: "八",
	nine: "九",
	ten: "十",
	"index_nihao":"ハーロー,{0}",
	"index_jipiao":"航空券",
	"index_jiudianzhusu":"ホテル",
	"index_huoche":"列車",
	"index_lvyoudujia":"旅游",
	"index_shangwuyonche": "商务用车",
	"index_jinqixingcheng": "最近の旅程	",
	"index_zhi":"まで",
	"index_jian":"室",
	"index_qushenpi":"承認します",
	"index_xiangqing":"詳細",
	"index_jiantizhongwen":"中国語",
	"index_jijiangchengxian":"近日公開！",
	"index_ditugongnengkaifazhong":"マップ機能は開発中です！",
	"index_jiudian":"ホテル",
	"index_huochepiao":"列車チケット",
	"index_yuyan":" 言語",

	"login_qingtianxiemima":"パスワードを入力してください",
	"login_wangjimima":"パスワードを忘れる",
	"login_qingshuruyanzhengma":"確認コードを入力してください",
	"login_fasongyanzhengma":"確認コードを送信する",
	"login_denglu":"ログインする",
	"login_yanzhengmadenglu":"確認コードログイン",
	"login_zhanghaomimadenglu":"アカウントパスワードログイン",
	"login_jiantizhongwen": "简体中文",
	"login_yingwen": "English",
	"login_riyu": "日本語",
	"login_denglujidaibiaonintongyiwomende":"ログインすると、に同意したことになります",
	"login_tongyi": "に同意",
	"login_butongyituichuapp": "同意せずアプリをログアウトします",
	"login_fuwuxieyi":"サービス契約",
	"login_fuwuxieyitext": "サービス契約",
	"login_he":"と",
	"login_byyzzbbhsyyhdgrysq": "このアプリは、すべてのユーザーのプライバシーを尊重し、保護します。",
	"login_wlgntggzq": "より正確にお届けするためです。",
	"login_gygxhdfw": "パーソナライズされたサービスを提供しています",
	"login_keyuedu": "読むことができます",
	"login_byyhazyszcdgdsyhplndgrxx": "このアプリケーションはプライバシーポリシーに基づいてあなたの個人情報を利用し、開示します。",
	"login_yinsizhengce":"個人情報保護方針",
	"login_yinsizhengcetext": "個人情報保護方針",
	"mall_flight_backtorule_fanhui":"戻る",
	"mall_flight_backtorule_tuigaiguize":"変更・キャンセル規則",
	"mall_flight_backtorule_goupiaoxuzhi":"チケット購入通知",
	"mall_flight_backtorule_nulihuoquzhong":"取得しようとしています...",
	"mall_flight_flight_chufadi":"出発地点",
	"mall_flight_flight_mudedi":"到着地点",
	"mall_flight_flight_chufashijian":"出発時間",
	"mall_flight_flight_fanchengshijian":"戻り時間",
	"mall_flight_flight_cangwei":"クラス",
	"mall_flight_flight_tianjialvke":"乗客を追加",
	"mall_flight_flight_dianjixuanzelvke":"クリックして乗客を選択",
	"mall_flight_flight_dianjixuanzecangwei": "選択席をクリックします",
	"mall_flight_flight_sousuo":"検索する",
	"mall_flight_flight_ruxuyudingertongyingerpiaoqinglianxibengongsikefu":"子供/幼児のチケットを予約する必要がある場合は、カスタマーサービスにお問い合わせください。",
	"mall_flight_flight_toudengcang":"ファーストクラス",
	"mall_flight_flight_shangwucang":"ビジネスクラス",
	"mall_flight_flight_jingjicang":"エコノミークラス",
	"mall_flight_flight_dancheng":"片道",
	"mall_flight_flight_wangfan":"往復",
	"mall_flight_flight_shanghai":"上海",
	"mall_flight_flight_beijing":"北京",
	"mall_flight_flight_guangzhou":"広州",
	"mall_flight_flight_yueri":"MM月DD日",
	"mall_flight_flight_qingxuanzelvke":"乗客を選択してください",
	"mall_flight_flight_shenpidanhangcheng": "離陸して都市に到着して1つの所属の許可があります単航程!",
    "mall_flight_flight_shenpidanchufariqi": "出発の日は決裁票の日の区間に合わせます!",
    "mall_flight_flight_shenpidanchufadaoda": "出発/帰路の日付は決裁票の日付の区間に合わせます!",
    "mall_flight_flight_shenpidanmudichengshi": "目的の都市は所属して決裁の単行程を承認します!",
	"mall_flight_flightchangeinfos_gaiqian":"変更",
	"mall_flight_flightchangeinfos_yuanhangbanxinxi":"元のフライト情報",
	"mall_flight_flightchangeinfos_di":"第",
	"mall_flight_flightchangeinfos_cheng":"回",
	"mall_flight_flightchangeinfos_yueri":"MM月DD日",
	"mall_flight_flightchangeinfos_tuigaiguize":"変更・キャンセルルール",
	"mall_flight_flightchangeinfos_xinhangbanxinxi":"新しいフライト情報",
	"mall_flight_flightchangeinfos_chuhangrenxinxi":"旅行者情報",
	"mall_flight_flightchangeinfos_shouji":"携帯電話：163 ****** 42",
	"mall_flight_flightchangeinfos_shenfenzheng":"ID：3424 ******** 0981",
	"mall_flight_flightchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"変更料金またキャンセル料金の規則は参照用であり、実際は航空会社の規則に従います",
	"mall_flight_flightchangeinfos_zongji":"合計：",
	"mall_flight_flightchangeinfos_mingxi":"明細",
	"mall_flight_flightchangeinfos_tijiaoshenhe":"承認提出",
	"mall_flight_flightchangeinfos_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したいのですが、飛びたくない",
	"mall_flight_flightchangeinfos_jicuohangchengriqishijianxingming":"旅程、日付、時刻、名前を見間違えた",
	"mall_flight_flightchangeinfos_hangbanyanwuhuoquxiao":"フライトの遅延またはキャンセル",
	"mall_flight_flightchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"御社の旅行基準に従って、変更の理由を選択してください",
	"mall_flight_flightchangeinfos_gongxinintijiaochenggongqingnaixindengdaikefuhejia":"おめでとうございます、送信は成功しました！ カスタマーサービスが価格を確認するまで辛抱強くお待ちください",
	"mall_flight_flightchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie":"現在の注文は変更できません。電話カスタマーサービスにご相談ください。ありがとうございます。",
	"mall_flight_flightdetails_hangbanxiangqing":"フライトの詳細",
	"mall_flight_flightdetails_zhifei":"直行",
	"mall_flight_flightdetails_yueri":"MM月DD日",
	"mall_flight_flightdetails_yixiafeiyongjunweichengrenhuoertonghuoyingerderenjunjia":"以下の料金は、「大人1名または子供1名または幼児1名」の1人あたりの平均価格です。",
	"mall_flight_flightdetails_shangwutuijian":"ビジネスの推奨事項",
	"mall_flight_flightdetails_baoxian":"保険+¥",
	"mall_flight_flightdetails_jinsheng":"残りわずか{0}",
	"mall_flight_flightdetails_zhang":"枚",
	"mall_flight_flightdetails_tuigaiguize":"変更・払戻",
	"mall_flight_flightdetails_weibeizhengce":"ポリシー違反",
	"mall_flight_flightdetails_fuhezhengce":"ポリシーに準拠",
	"mall_flight_flightdetails_ding":"予約",
	"mall_flight_flightdetails_tuipiaozhongkai":"払い戻しと再発券",
	"mall_flight_flightdetails_tuigaishiduan":"変更．キャンセル期間",
	"mall_flight_flightdetails_tuipiaofeiyong":"キャンセル料金",
	"mall_flight_flightdetails_gaiqianfeiyong":"変更料金",
	"mall_flight_flightdetails_qian":"前です",
	"mall_flight_flightdetails_ren":"￥/人",
	"mall_flight_flightdetails_hanglie":"手荷物制限",
	"mall_flight_flightdetails_yihangkonggongsizuixinguidingweizhunkezixunkefudianhua":"最新の航空会社の規制の対象には、顧客サービスの電話番号を相談することができます",
	"mall_flight_flightdetails_yscrtgqgzjfybzjgcksj":"上記の大人変更料金及びキャンセル料金基準は参照用でまで、実際の基準は航空会社に従いします",
	"mall_flight_flightdetails_tuigaiguizeyihangsishenheweizhun":"変更料金及びキャンセル料金基準は航空会社に従いします",
	"mall_flight_flightdetails_yudingtuijianhangban": "格安便を予約したいです",
	"mall_flight_flightdetails_jixuyudingyuanhangban": "元の便を引き続き予約します",
	"mall_flight_flightdetails_gjgsclzctjnyddjhb": "会社の出張政策によって、安い便を予約することをお勧めします。",
	"mall_flight_flightdetails_weibei":"違反する",
	"mall_flight_flightdetails_qingyihangsishenheweizhun":"航空会社の承認を準じます",
	"mall_flight_flightdetails_gaihangbanweiyinbeiguizebukeyuding":"ルール違反のため予約できません",
	"mall_flight_flightdetails_nsyddxyjgxytqbàcngsy":"予約した契約価格は、使用する前に事前に提出する必要があります。サービスホットライン4000888020までお電話ください。ありがとうございます。",
	"mall_flight_flightdetails_zhe":"{0}オフ",//这个折扣也存在问题
	"mall_flight_flightlist_zhongzhuan":"乗り継ぎ",
	"mall_flight_flightlist_jinsheng":"残りわずか",
	"mall_flight_flightlist_zhang":"枚",
	"mall_flight_flightlist_chongzu":"十分",
	"mall_flight_flightlist_jingting":"経由",
	"mall_flight_flightlist_weibeiguize":"ルールに違反する",
	"mall_flight_flightlist_fuhezhengce":"ポリシーに準拠",
	"mall_flight_flightlist_jiazaizhong":"読み込んでいます...",
	"mall_flight_flightlist_shanghai":"上海",
	"mall_flight_flightlist_beijing":"北京",
	"mall_flight_flightorder_zhifei":"直行",
	"mall_flight_flightorder_yueri":"MM月DD日",
	"mall_flight_flightorder_piaojia":"運賃",
	"mall_flight_flightorder_yuan":"{0}CNY",
	"mall_flight_flightorder_jijianranyou":"空港建設基金/燃料サーチャージ",
	"mall_flight_flightorder_yuanren":"元/人",
	"mall_flight_flightorder_baoxian":"保険",
	"mall_flight_flightorder_hangbanxiangqing":"フライトの詳細",
	"mall_flight_flightorder_xuanzechuhangren":"旅行者を選ぶ",
	"mall_hotel_hotel_ruzhushijian":"チェックイン",
	"mall_hotel_hotel_gong":"合計",
	"mall_hotel_hotel_wan":"泊",
	"mall_hotel_hotel_lidianshijian":"チェックアウト",
	"mall_hotel_hotel_guanjianziweizhipinpaijiudianming":"キーワード/場所/ブランド/ホテル名",
	"mall_hotel_hotel_qingshuruguanjianziweizhipinpaijiudianming":"キーワード/場所/ブランド/ホテル名を入力してください",
	"mall_hotel_hotel_tianjialvke":"乗客を追加",
	"mall_hotel_hotel_dianjixuanzelvke":"クリックして乗客を選択",
	"mall_hotel_hotel_sousuo":"検索する",
	"mall_hotel_hotel_dfjqbycgjrzrqbycgwrx":"5部屋以上の予約はご遠慮ください。チェックイン日は20泊を超えないようにしてください。 特別予約については、カスタマーサービスまでお問い合わせください。",
	"mall_hotel_hotel_shanghai":"上海",
	"mall_hotel_hotel_yueri":"MM月DD日",
	"mall_hotel_hotel_qingxuanzelvke":"乗客を選択してください",
	"mall_hotel_hotel_lvkeshuliangshangxianqinglianxikefu":"乗客数の上限になります、カスタマーサービスまでご連絡ください",
	"mall_hotel_hotel_wenxintishi":"ヒント",
	"mall_hotel_hotel_zxydcgwfyknbzjylxkfh":"20泊以上のオンライン予約では、空き状況が不十分な場合があります。その他の住宅プランについては、カスタマーサービスにお問い合わせください。",
	"mall_hotel_hotel_jixuyuding":"予約を続ける",
	"mall_hotel_hotel_lianxikefu":"カスタマーサービスにお問い合わせください",
	"mall_hotel_hoteldetails_fanhui":"戻る",
	"mall_hotel_hoteldetails_pingfen":"スコア",
	"mall_hotel_hoteldetails_fen":"点",
	"mall_hotel_hoteldetails_zanwupingfen":"まだ評価はありません",
	"mall_hotel_hoteldetails_xingji":"星評価",
	"mall_hotel_hoteldetails_tingchechang":"駐車場",
	"mall_hotel_hoteldetails_jianshenfang":"ジム",
	"mall_hotel_hoteldetails_hanglijicun":"荷物置き場",
	"mall_hotel_hoteldetails_dizhi":"住所：{0}",
	"mall_hotel_hoteldetails_dianhua":"電話：{0}",
	"mall_hotel_hoteldetails_yueri":"M月DD日",
	"mall_hotel_hoteldetails_ruzhu":"チェックイン",
	"mall_hotel_hoteldetails_lidian":"チェックアウト",
	"mall_hotel_hoteldetails_wan":"泊",
	"mall_hotel_hoteldetails_jianren":"室／人",
	"mall_hotel_hoteldetails_qi":"￥{0}から",
	"mall_hotel_hoteldetails_zao":"朝",
	"mall_hotel_hoteldetails_kezhu":"入居可能",
	"mall_hotel_hoteldetails_ren":"人",
	"mall_hotel_hoteldetails_bukequxiao":"不可取消",
	"mall_hotel_hoteldetails_fuhezhengce":"ポリシーに準拠",
	"mall_hotel_hoteldetails_weibeizhengce":"ポリシー違反",
	"mall_hotel_hoteldetails_yuding":"予約",
	"mall_hotel_hoteldetails_gaijiudianzanwuheshifangjian":"このホテルには適切な部屋がありません！",
	"mall_hotel_hoteldetails_xieyijiudian":"合議ホテル",
	"mall_hotel_hoteldetails_wu":"無い",
	"mall_hotel_hoteldetails_dan":"シングル",
	"mall_hotel_hoteldetails_shuang":"ダブル",
	"mall_hotel_hoteldetails_duo":"多数",
	"mall_hotel_hoteldetails_weibei":"違反する",
	"mall_hotel_hoteldetails_gaifangjianyinweibeiguizebukeyuding":"規則違反のため予約できません",
	"mall_hotel_hoteldetails_wenxintishi":"ヒント",
	"mall_hotel_hoteldetails_bjdwxyjdknczfxqnzxbh":"このホテルは合議ホテルです、リスクがあるかもしれません、あなたの旅行を気づいてそして合理的に手配してください、ありがとう！",
	"mall_hotel_hotellist_meiyougengduoliao":"以上です。",
	"mall_hotel_hotellist_qi":"￥{0}から",
	"mall_hotel_hotellist_fen":"分",
	"mall_hotel_hotellist_weibeiguize":"ルールに違反する",
	"mall_hotel_hotellist_fuhezhengce":"ポリシーに準拠",
	"mall_hotel_hotellist_jiazaizhong":"読み込んでいます...",
	"mall_hotel_hotellist_xieyijiudian":"契約ホテル",
	"mall_hotel_hotelorder_ruzhu":"チェックイン：",
	"mall_hotel_hotelorder_wan":"泊",
	"mall_hotel_hotelorder_lidian":"チェックアウト：",
	"mall_hotel_hotelorder_jian":"／室",
	"mall_hotel_hotelorder_dingdanquerenhoubukequxiao":"ご注文は確認成功次第にキャンセルはできません",
	"mall_hotel_hotelorder_tuigaixiangqing":"変更・払い戻しの詳細",
	"mall_hotel_hotelorder_ruzhuxinxi":"チェックイン情報",
	"mall_hotel_hotelorder_dingdantianxie":"注文入力",
	"mall_hotel_hotelorder_yueri":"M月DD日",
	"mall_modules_addpassengers_fanhui":"戻る",
	"mall_modules_addpassengers_tianjiachengke":"乗客を追加する",
	"mall_modules_addpassengers_wancheng":"完成",
	"mall_modules_addpassengers_qingshurulvkemingchengpipeihuotianjiaweilinke":"一致または臨時客として追加する乗客の名前を入力してください。",
	"mall_modules_addpassengers_tianjia":"+ 追加",
	"mall_modules_addpassengers_wei":"は",
	"mall_modules_addpassengers_linke":"臨時客",
	"mall_modules_addpassengers_shanchu":"削除",
	"mall_modules_addpassengers_qingjianglinkemingchengshurudaosousuokuangneihouzhongshi":"検索ボックスに臨時客の名前を入力して、もう一度お試しください",
	"mall_modules_change_gaiqian":"変更",
	"mall_modules_change_gaiqianyuanyin":"変更理由",
	"mall_modules_change_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"変更・キャンセルの規則および料金は、航空会社に準ずる",
	"mall_modules_change_xiayibuqingxuanzegaiqianriqi":"次、変更日を選択してください",
	"mall_modules_change_tuigaiguize":"変更・キャンセル規則",
	"mall_modules_change_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したいのですが、飛びたくない",
	"mall_modules_change_jicuohangchengriqishijianxingming":"旅程、日付、時刻、名前を見間違えた",
	"mall_modules_change_hangbanyanwuhuoquxiao":"フライトの遅延またはキャンセル",
	"mall_modules_change_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"御社の旅行基準に従って、変更の理由を選択してください",
	"mall_modules_change_qingxuanzexuyaogaiqiandelvcheng":"変更が必要な旅程を選択してください",
	"mall_modules_change_qingxuanzelvke":"乗客を選択してください",
	"mall_modules_change_shanghai":"上海",
	"mall_modules_change_beijing":"北京",
	"mall_modules_change_gaichecimeiyoupipeituigaiguize":"本列車には該当するの変更・キャンセル規則がありません",
	"mall_modules_choosecontraryreason_weibeiyuanyin":"違反の理由",
	"mall_modules_choosecontraryreason_qingshuruliyoumingcheng":"理由名を入力してください",
	"mall_modules_choosecostcenter_chengbenzhongxin":"コストセンター",
	"mall_modules_chooseprojectcode_qingshuruxiangmudaima":"プロジェクトコードを入力してください",
	"mall_modules_chooseprojectcode_tianjia":"追加",
	"mall_modules_chooseprojectcode_weixiangmudaima":"はプロジェクトコード",
	"mall_modules_choosetripintent_chalvmude":"旅行の目的",
	"mall_modules_choosetripintent_qingshuruchalvmude":"旅行の目的を入力してください",
	"mall_modules_editrole_fanhui":"戻る",
	"mall_modules_editrole_tianjialinke":"臨時客を追加",
	"mall_modules_editrole_xingpinyin":"姓（ローマ字）",
	"mall_modules_editrole_mingpinyin":"名（ローマ字）",
	"mall_modules_editrole_zhongwenxingming":"中国語の名前",
	"mall_modules_editrole_qingshuruxingming":"名前を入力してください",
	"mall_modules_editrole_zhengjianleixing":"証明書の種類",
	"mall_modules_editrole_dianjixuanzezhengjianleixing":"クリックして証明書の種類を選択します",
	"mall_modules_editrole_xingbie":"性別",
	"mall_modules_editrole_dianjixuanzexingbie":"クリックして性別を選択",
	"mall_modules_editrole_guoji":"国籍",
	"mall_modules_editrole_dianjixuanzeguoji":"クリックして国籍を選択",
	"mall_modules_editrole_zhengjianhaoma":"証明書番号",
	"mall_modules_editrole_qingshuruzhengjianhaoma":"証明書番号を入力してください",
	"mall_modules_editrole_chushengriqi":"生年月日",
	"mall_modules_editrole_dianjixuanzechushengriqi":"クリックして生年月日を選択",
	"mall_modules_editrole_shoujihaoma":"携帯電話番号",
	"mall_modules_editrole_qingshurushoujihaoma":"携帯番号を入力してください",
	"mall_modules_editrole_youxiang": "メールボックス",
	"mall_modules_editrole_qingtianxieyouxianghaoma": "请填写邮箱号码",
	"mall_modules_editrole_sfbcwck": "常連として保存されていますか？",
	"mall_modules_editrole_baocun":"セーブ",
	"mall_modules_editrole_lichenggongsi":"力程ビジネストラベル",
	"mall_modules_editrole_nan":"男",
	"mall_modules_editrole_nv":"女",
	"mall_modules_editrole_zhongguo":"中国",
	"mall_modules_frequentercardfill_fanhui":"戻る",
	"mall_modules_frequentercardfill_tianxiechangkelvkeqia":"会員番号を入力してください",
	"mall_modules_frequentercardfill_zhangsan":"張三",
	"mall_modules_frequentercardfill_qingxuanzehangkonggongsi":"航空会社を選択してください",
	"mall_modules_frequentercardfill_qingtianxiechanglvkeqiahao":"会員番号を入力してください",
	"mall_modules_frequentercardfill_wancheng":"完成",
	"mall_modules_frequentercardfill_dongfanghangkong":"チャイナイースタンエアラインズ",
	"mall_modules_frequentercardfill_zhongguohangkong":"チャイナエアライン",
	"mall_modules_frequentercardfill_nanfanghangkong":"チャイナサザンエアラインズ",
	"mall_modules_productdetails_fanhui":"戻る",
	"mall_modules_producthome_chalvguizemingcheng":"旅行ルール名：",
	"mall_modules_producthome_guoji": "国際",
	"mall_modules_producthome_guonei": "国内",
	"mall_modules_producthome_jipiaofuwu": "航空券のサービス",
	"mall_modules_producthome_jiudianfuwu": "ホテルのサービス",
	"mall_modules_producthome_huochefuwu": "列車サービス",
	"mall_modules_producthome_zuidijiagejizhun":"最低価格ベンチマーク：",
	"mall_modules_producthome_shishihangbanguankong":"リアルタイムのフライトコントロール：",
	"mall_modules_producthome_tiqianyudingshijian":"事前予約時間：",
	"mall_modules_producthome_cangweijibiexianzhi":"クラスの制限：",
	"mall_modules_producthome_zuoweijibiexianzhi":"座席クラスの制限：",
	"mall_modules_producthome_xieyijipiaoyouxian":"契約航空券優先：",
	"mall_modules_producthome_xieyijiudianyouxian":"合議ホテル優先：",
	"mall_modules_producthome_xiaofeijineshangxian":"消費金額上限",
	"mall_modules_producthome_shenpimingcheng":"承認名：",
	"mall_modules_producthome_toudengcang":"ファーストクラス",
	"mall_modules_producthome_shangwucang":"ビジネスクラス",
	"mall_modules_producthome_jingjicang":"エコノミークラス",
	"mall_modules_producthome_jingjicang5zhe":"エコノミークラス（50％オフ）",
	"mall_modules_producthome_jingjicang6zhe":"エコノミークラス（60％オフ）",
	"mall_modules_producthome_jingjicang7zhe":"エコノミークラス（70％オフ）",
	"mall_modules_producthome_jingjicang8zhe":"エコノミークラス（80％オフ）",
	"mall_modules_producthome_jingjicang9zhe":"エコノミークラス（90％オフ）",
	"mall_modules_producthome_yinei":"以内に",
	"mall_modules_producthome_bufenhangxian":"一部ルート",
	"mall_modules_producthome_bufenjiudian":"一部ホテル",
	"mall_modules_producthome_jichengshiyinei":"次都市{1}-{2}内",
	"mall_modules_productlist_fanhui":"戻る",
	"mall_modules_productlist_tuigaiguize":"変更・キャンセル規則",
	"mall_modules_productlist_zhu":"チェックイン",
	"mall_modules_productlist_li":"チェックアウト",
	"mall_modules_productlist_guanjianziweizhijiudianmingpinpai":"キーワード/場所/ホテル名/ブランド",
	"mall_modules_productlist_qianyitian":"前日",
	"mall_modules_productlist_houyitian":"翌日",
	"mall_modules_productlist_weizhijuli":"位置距離",
	"mall_modules_productlist_jiagexingji":"価格/星",
	"mall_modules_productlist_shaixuan":"絞り込み",
	"mall_modules_productlist_queren":"確認",
	"mall_modules_productlist_gengduoshaixuan":"もっと絞り込み",
	"mall_modules_productlist_chalvguizemingcheng":"旅行ルール名：",
	"mall_modules_productlist_zuidijiagejizhun":"最低価格ベンチマーク：",
	"mall_modules_productlist_shishihangbanguankong":"リアルタイムのフライトコントロール：",
	"mall_modules_productlist_tiqianyudingshijian":"事前予約時間：",
	"mall_modules_productlist_cangweijibiexianzhi":"クラスの制限：",
	"mall_modules_productlist_zuoweijibiexianzhi":"座席クラスの制限：",
	"mall_modules_productlist_xieyijipiaoyouxian":"契約航空券優先：",
	"mall_modules_productlist_xieyijiudianyouxian":"合議ホテル優先：",
	"mall_modules_productlist_xiaofeijineshangxian":"消費金額上限",
	"mall_modules_productlist_shenpimingcheng":"承認名：",
	"mall_modules_productlist_toudengcang":"ファーストクラス",
	"mall_modules_productlist_shangwucang":"ビジネスクラス",
	"mall_modules_productlist_jingjicang":"エコノミークラス",
	"mall_modules_productlist_jingjicangzhe":"エコノミークラス（50％オフ）",
	"mall_modules_productlist_hangzhengqu":"行政区",
	"mall_modules_productlist_buxian":"無制限",
	"mall_modules_productlist_shangyequ":"ビジネス街",
	"mall_modules_productlist_jiage":"価格",
	"mall_modules_productlist_yixia":"¥ 150以下",
	"mall_modules_productlist_yishang":"¥ 600以上",
	"mall_modules_productlist_xingji":"星評価",
	"mall_modules_productlist_erxingjijiyixia":"2つ星以下",
	"mall_modules_productlist_sanxingjishushi":"3つ星/快適",
	"mall_modules_productlist_sixingjigaodang":"4つ星/高級",
	"mall_modules_productlist_wuxingjihaohua":"5つ星/豪華",
	"mall_modules_productlist_tese":"注目の",
	"mall_modules_productlist_fuwu":"サービス",
	"mall_modules_productlist_chexingxuanze":"モデルの選択",
	"mall_modules_productlist_gaotie":"高速レール（G / C）",
	"mall_modules_productlist_dongche":"自動車（D）",
	"mall_modules_productlist_putong":"通常（Z / T / K）",
	"mall_modules_productlist_qitadeng":"その他（L / Y等）",
	"mall_modules_productlist_qita":"その他",
	"mall_modules_productlist_facheshijian":"出発時間",
	"mall_modules_productlist_chalvzhengce":"旅行ポリ​​シー",
	"mall_modules_productlist_fuhezhengce":"ポリシーに準拠",
	"mall_modules_productlist_weibeiguize":"ルールに違反する",
	"mall_modules_productlist_chufachezhan":"出発駅",
	"mall_modules_productlist_daodachezhan":"到着駅",
	"mall_modules_productlist_zhinengpaixu":"スマートソーティング",
	"mall_modules_productlist_morenpaixu":"標準の並べ替え",
	"mall_modules_productlist_dijiayouxian":"格安優先",
	"mall_modules_productlist_gaojiayouxian":"高価格優先",
	"mall_modules_productlist_xingjiyouxian":"スターの優先順位",
	"mall_modules_productlist_putongyouxian":"ノーマル優先",
	"mall_modules_productlist_shijianpaixu":"時間順",
	"mall_modules_productlist_congzaodaowan":"早い順",
	"mall_modules_productlist_congwandaozao":"遅い順",
	"mall_modules_productlist_jiagepaixu":"価格ソート",
	"mall_modules_productlist_congdidaogao":"安い順",
	"mall_modules_productlist_conggaodaodi":"高い順",
	"mall_modules_productlist_qifeishijian":"出発時間",
	"mall_modules_productlist_qifeijichang":"出発空港",
	"mall_modules_productlist_daodajichang":"到着空港",
	"mall_modules_productlist_cangwei":"クラス",
	"mall_modules_productlist_hangkonggongsi":"航空会社",
	"mall_modules_productlist_yinei":"以内に",
	"mall_modules_productlist_bufenhangxian":"一部のルート",
	"mall_modules_productlist_bufenjiudian":"一部のホテル",
	"mall_modules_productlist_jichengshiyinei":"次都市​​{1}内",
	"mall_modules_addkeywords_guanjianziweizhijiudianmingpinpai": "キーワード/場所/ホテル名/ブランド",
	"mall_modules_addkeywords_qsrhxggjzwzppjdmckssjg": "キーワード/位置/ブランド/ホテル名を入力または変更して検索結果を調べてください。",
	"mall_modules_refund_tuidingyuanyin":"キャンセル理由",
	"mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"変更・キャンセルの規則および料金は、航空会社に準ずる",
	"mall_modules_refund_zongji":"合計：",
	"mall_modules_refund_yujituipiaofei": "预计退票费：",
	"mall_modules_refund_mingxi":"明細",
	"mall_modules_refund_tijiaoshenhe":"承認提出",
	"mall_modules_refund_hangchengbiangeng":"旅程変更",
	"mall_modules_refund_hangchengquxiao":"旅程をキャンセル",
	"mall_modules_refund_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したいのですが、飛びたくない",
	"mall_modules_refund_jicuohangchengriqishijianxingming":"旅程、日付、時刻、名前を見間違えた",
	"mall_modules_refund_hangbanyanwuhuoquxiao":"フライトの遅延またはキャンセル",
	"mall_modules_refund_genjuguisidechalvbiaozhunqingxuanzetuidingyuanyin":"御社の旅行基準に従って、購読を解除する理由を選択してください",
	"mall_modules_refund_shenqingtuipiao":"払い戻しをリクエストする",
	"mall_modules_refund_shenqingtuifang":"チェックアウトに申し込む",
	"mall_modules_refund_qingxuanzexuyaotuidingdelvcheng":"キャンセルしたいの旅程を選択してください",
	"mall_modules_refund_qingxuanzelvke":"乗客を選択してください",
	"mall_modules_refund_qingxuanzetuidingyuanyin":"キャンセルの理由をお選びください",
	"mall_modules_refund_tuipiaoshenqingtijiaochenggong":"払い戻し申請が正常に送信されました",
	"mall_modules_remarks_xuqiubeizhu":"特別要件入力",
	"mall_modules_remarks_baocun":"セーブ",
	"mall_modules_remarks_ndtsxqwmhjlxtrwfmzwm":"私たちはあなたの特別なニーズに合わせて最善を尽くします。 満足できない場合は別途お知らせいたしませんのでご容赦ください",
	"mall_order_shifa":"出発",
	"mall_order_jingting": "やめる",
	"mall_order_yueri":"MM月DD日 ddd",
	"mall_order_tuigaixuzhi": "退改须知",
	"mall_order_fangjianshu":"室数",
	"mall_order_jian":"室",
	"mall_order_rfjcgwjsklxkfhcfyd": "若房间超过5间时，可联系客服或拆分预订！",
	"mall_order_meijianzuiduokezhu":"各部屋はX人まで収容できます",
	"mall_order_ren":"人",
	"mall_order_zuoxixuanze": "座席选择",
	"mall_order_chuang": "窗",
	"mall_order_guodao": "过道",
	"mall_order_wbzndslcxqwbbztxxycysczjyz":"为了您顺利出行，请务必保证填写项与出游所持证件一致",
	"mall_order_fasongduanxin":"メッセージを送る",
	"mall_order_baoxianxinxi":"保険情報",
	"mall_order_yqqjjqfhslrsbxdzfwyf":"COVID-19パンデミック時の保護の強化、ビジネス旅行者向けのカスタマイズされた保険サービス、1つの保護、家族全員の安心",

	"mall_order_shanglvxinxi":"出張情報",
	"mall_order_shenpipingzheng": "承認証明書",
	"mall_order_youshenpipingzheng": "承認証明書あり",
	"mall_order_wushenpipingzheng": "承認証明書なし",
	"mall_order_shenpizhuangtai": "承認データ",
	"mall_order_chuchaishenqingiworkyishenpi": "lworkerから承認済み",
	"mall_order_shangweishenpi": "承認中",
	"mall_order_yijishenpi": "一級承認",


	"mall_order_shenpidanhao":"承認番号",
	"mall_order_liuchenglingdaochuchabaogaodanhao":"IMISプロセスリーダーの出張レポート番号",
	"mall_order_chengbenzhongxin":"コストセンター",
	"mall_order_qingxuanzechengbenzhongxin":"コストセンターを選択してください",
	"mall_order_chalvmude":"旅行の目的",
	"mall_order_qingxuanzechalvmude":"旅行目的を選択してください",
	"mall_order_mudexiangqing":"目的の詳細",
	"mall_order_chalvmudebumingquexubuchongxiangxichalvmude":"旅行の目的は明確ではありません、旅行の詳細な目的を追加する必要があります",
	"mall_order_xiangmudaima":"プロジェクトコード",
	"mall_order_qingxuanzexiangmudaima":"プロジェクトコードを選択してください",
	"mall_order_weibeiyuanyin":"違反の理由",
	"mall_order_yusuanbianma": "予算コードです",
	"mall_order_fujianxinxi": "添付ファイル情報です",
	"mall_order_yusuanmiaoshu": "予算の記述です",
	"mall_order_xingchengweibeile": "スケジュールがずれています",
	'mall_order_dezhengce': "政策です",
	"mall_order_qingxuanzeweibeiyuanyin":"違反の理由を選択してください",
	"mall_order_xiangxiyuanyin":"詳細な理由",
	"mall_order_lianxirenxinxi":"連絡先情報",
	"mall_order_xingming":"名前",
	"mall_order_qingshuruyonghuming":"ユーザー名を入力してください",
	"mall_order_shouji":"携帯電話",
	"mall_order_qingshurushoujihao":"携帯番号を入力してください",
	"mall_order_youxiang":"メールボックス",
	"mall_order_qingshuruyouxiang":"メールアドレスを入力してください",
	"mall_order_xuqiubeizhu":"デマンドノート",
	"mall_order_koukuanshuoming":"お支払い説明",
	"mall_order_hgjndfkfsjhysqhkcffr":"お支払い方法に応じて事前承認または客室料金の差し引きを行いますので、ご注文が確定しない場合は事前承認を取り消すか、お支払い口座に全額返金いたします。 ご注文確定後のキャンセル・変更はできません。チェックインしない場合は初日の宿泊料金、早めの退店の場合は早めのご出発日の料金が発生します。",
	"mall_order_tebietishi":"特記事項：",
	"mall_order_gjddrzsjwtfbzjssjwrt":"ホテルのチェックイン時間は14:00で、標準のチェックアウト時間は12:00です。 アーリーチェックインやレイトチェックアウトなど、必要に応じて一定の料金がかかります。",
	"mall_order_mingxi":"明細",
	"mall_order_tijiaozhifu":"提出/支払い",
	"mall_order_feiyongmingxi":"料金の明細",
	"mall_order_baoxianfei":"保険料金",
	"mall_order_fuwufei":"サービス料金",
	"mall_order_zonge":"合計金額",
	"mall_order_dingdanzhengzaishengcheng":"注文が生成されています...",
	"mall_order_nulizhanzuozhong":"席を予約しています...",
	"mall_order_tuipiaoshuoming":"払い戻しの説明",
	"mall_order_dgcgwqpqfcqsjdyfzkjr":"1.購入が成功し、チケットが収集されず、出発までの時間が35分を超える場合は、「私の注文」の中で、列車の注文をクリックして、プロンプトに従って払い戻しを申請できます。出発前15日以内の払い戻しの場合、鉄道局はチケットの払い戻し料金を請求します。",
	"mall_order_dgcgyqphfcqsjxyfzxnz":"2.購入が成功し、チケットが回収された場合、または出発までの時間が35分未満の場合は、チケットの購入時に使用したの有効な乗客IDと列車のチケットを持参し、鉄道駅の窓口に移動して、出発前に払い戻しを処理する必要があります。",
	"mall_order_gaiqianshuoming":"変更説明",
	"mall_order_wqzzpqlfcsjdyfzkgqdy":"1.紙のチケットを受け取らず、出発までの時間が35分を超える場合は、元のチケット料金以下の列車の数を変更できます。 オンラインで変更できないその他の場合は、出発前に駅の窓口に行ってください。",
	"mall_order_kcqxsyskgqysqndcckcq":"2.運転前の48時間以上、プレセール期間中に車の数を変更することができます。 運転の48時間以内であれば、当日の24:00までに任意の数の列車にチケットを変更でき、チケットの翌日以降はチケットを変更できません。",
	"mall_order_xcppjdyycpdthcédcébf":"3.新しいチケットの運賃が元のチケットよりも低い場合、差額は返金され、差額に対して返金料金が請求され、現在の返金料金基準が実施されます。",
	"mall_order_querendingdan":"注文確認",
	"mall_order_xuanzechuhangren":"旅行者を選ぶ",
	"mall_order_lichenggongsi":"力程ビジネストラベル",
	"mall_order_yi":"一",
	"mall_order_er":"二",
	"mall_order_san":"三",
	"mall_order_yueri1":"MM月DD日",
	"mall_order_qingtianxiexiangmudaima":"プロジェクトコードを入力してください",
	"mall_order_qingtianxieshenpidanhao":"承認番号を入力してください",
	"mall_order_qingtianxiechalvmude":"旅行の目的を記入してください",
	"mall_order_qingtianxiexiangqingmude":"詳細な目的を記入してください",
	"mall_order_qingtianxieweibeixiangqingyuanyin":"違反の理由の詳細を記入してください",
	"mall_order_ghbjpwzhxscpnxxzyzbx":"このフライトチケットはコンビネーションセール商品ですので、保険商品をお選びいただく必要があります。 または別のフライトチケットを選択してください",
	"mall_order_gcczxwzhxscpnxxzyzbx":"この列車の座席は複合販売商品ですので、保険商品をお選びいただく必要があります。 または別の列車を選択してください",
	"mall_order_qingtianxielvkezhengjianhaoma":"乗客証明書番号を入力してください",
	"mall_order_wenxintishi":"ヒント！",
	"mall_order_shifoujixuyuding":"予約を続けるかどうか",
	"mall_order_ddcjcghynsszddxxzgzd":"注文は正常に作成されました。いつでも注文の詳細で注文の進行状況を確認できます。",
	"mall_order_hejiazhong":"価格を確認しています...",
	"mall_order_fangjianshubukedayuruzhurenshu":"部屋の数は、居住者の数を超えることはできません",
	"mall_train_train_chufadi":"出発地点",
	"mall_train_train_mudedi":"到着地点",
	"mall_train_train_chufashijian":"出発時間",
	"mall_train_train_zuoxi":"席",
	"mall_train_train_yidengzuo":"ファーストクラスの座席",
	"mall_train_train_tianjialvke":"乗客を追加",
	"mall_train_train_dianjixuanzelvke":"クリックして乗客を選択",
	"mall_train_train_sousuo":"検索する",
	"mall_train_train_dangqianshiduanbutigongchecichaxunfuwu":"現時点では列車番号照会サービスは提供されていません",
	"mall_train_train_tsgpsjwzwgpgqhtpxbwy":"注意：チケットの購入時間は午前5時30分から午後23時00分までです。 チケットの購入、変更、払い戻しは、発車の30分前までに行う必要があります。 同日以内の旅程は10分以内、24時間を超える旅程は25分以内にお支払いください。",
	"mall_train_train_shanghai":"上海",
	"mall_train_train_beijing":"北京",
	"mall_train_train_yueri":"MM月DD日",
	"mall_train_train_qingxuanzelvke":"乗客を選択してください",
	"mall_train_trainchangeinfos_gaiqian":"変更",
	"mall_train_trainchangeinfos_yuanchecixinxi":"元の列車番号情報",
	"mall_train_trainchangeinfos_di":"第",
	"mall_train_trainchangeinfos_cheng":"回",
	"mall_train_trainchangeinfos_yueri":"MM月DD日",
	"mall_train_trainchangeinfos_tuigaiguize":"変更・キャンセル規則",
	"mall_train_trainchangeinfos_xinchecixinxi":"新しい列車情報",
	"mall_train_trainchangeinfos_chuhangrenxinxi":"旅行者情報",
	"mall_train_trainchangeinfos_shouji":"携帯電話：163 ****** 42",
	"mall_train_trainchangeinfos_shenfenzheng":"身分証明書：3424 ******** 0981",
	"mall_train_trainchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyishijishenheweizhun":"変更・キャンセルの規則および料金は、航空会社に準ずる",
	"mall_train_trainchangeinfos_zongji":"合計：",
	"mall_train_trainchangeinfos_mingxi":"明細",
	"mall_train_trainchangeinfos_tijiaoshenhe":"承認提出",
	"mall_train_trainchangeinfos_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したいのですが、飛びたくない",
	"mall_train_trainchangeinfos_jicuohangchengriqishijianxingming":"旅程、日付、時刻、名前を見間違えた",
	"mall_train_trainchangeinfos_hangbanyanwuhuoquxiao":"フライトの遅延またはキャンセル",
	"mall_train_trainchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"御社の旅行基準に従って、変更の理由を選択してください",
	"mall_train_trainchangeinfos_gaiqianchenggongqingninguanzhudingdanzhuangtai":"変更は成功しました。注文のステータスに注意してください。",
	"mall_train_trainchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie":"現在の注文は変更できません。カスタマーサービスにご相談ください。ありがとうございます。",
	"mall_train_traindetails_checixiangqing":"列車の詳細",
	"mall_train_traindetails_tuigaiguize":"変更・キャンセル規則",
	"mall_train_traindetails_shifa":"出発",
	"mall_train_traindetails_weibeizhengce":"ポリシー違反",
	"mall_train_traindetails_fuhezhengce":"ポリシーに準拠",
	"mall_train_traindetails_youpiao":"チケットがあります",
	"mall_train_traindetails_wupiao":"売り切れ",
	"mall_train_traindetails_jinsheng":"残りわずか",
	"mall_train_traindetails_zhang":"枚",
	"mall_train_traindetails_ding":"予約",
	"mall_train_traindetails_tuipiaoshuoming":"払い戻しの説明",
	"mall_train_traindetails_dgcgwqpqfcqsjdyfzkjr":"1.購入が成功し、チケットが収集されず、出発までの時間が35分を超える場合は、「私の注文」の中で、列車の注文をクリックして、プロンプトに従って払い戻しを申請できます。出発前15日以内の払い戻しの場合、鉄道局はチケットの払い戻し料金を請求します。",
	"mall_train_traindetails_dgcgyqphfcqsjxyfzxnz":"2.購入が成功し、チケットが回収された場合、または出発までの時間が35分未満の場合は、チケットの購入時に使用したの有効な乗客IDと列車のチケットを持参し、鉄道駅の窓口に移動して、出発前に払い戻しを処理する必要があります。",
	"mall_train_traindetails_gaiqianshuoming":"変更説明",
	"mall_train_traindetails_wqzzpqlfcsjdyfzkgqdy":"1.紙のチケットを受け取らず、出発までの時間が35分を超える場合は、元のチケット料金以下の列車の数を変更できます。 オンラインで変更できないその他の場合は、出発前に駅の窓口に行ってください。",
	"mall_train_traindetails_kcqxsyskgqysqndcckcq":"2.運転前の48時間以上、プレセール期間中に車の数を変更することができます。 運転の48時間以内であれば、当日の24:00までに任意の数の列車にチケットを変更でき、チケットの翌日以降はチケットを変更できません。",
	"mall_train_traindetails_xcppjdyycpdthcédcébf":"3.新しいチケットの運賃が元のチケットよりも低い場合、差額は返金され、差額に対して返金料金が請求され、現在の返金料金基準が実施されます。",
	"mall_train_traindetails_weibei":"違反する",
	"mall_train_trainlist_weibeiguize":"ルールに違反する",
	"mall_train_trainlist_fuhezhengce":"ポリシーに準拠",
	"mall_train_trainlist_shouqi":"納める",
	"mall_train_trainlist_zhankai":"展開",
	"mall_train_trainlist_you":"あり",
	"mall_train_trainlist_zhang":"枚",
	"mall_train_trainlist_wu":"無い",
	"mall_train_trainlist_zhanxu":"駅の順番",
	"mall_train_trainlist_zhanming":"駅名",
	"mall_train_trainlist_daoshi":"到着時間",
	"mall_train_trainlist_fashi":"出発時間",
	"mall_train_trainlist_tingliu":"滞在",
	"mall_train_trainlist_jiazaizhong":"読み込んでいます...",
	"mall_train_trainlist_xiuxizhongmingtianzailai":"休み中、また明日",
	"mall_train_trainlist_dqcczxwypqnlxqtcchlā":"現在の列車の座席はもうありません！別の列車を選んで、合理的に旅行を手配してください、ありがとう！",
	"mall_train_trainlist_qita":"その他",
	"mall_train_trainorder_zhifei":"直行",
	"mall_train_trainorder_yueri":"MM月DD日",
	"mall_train_trainorder_piaojia":"運賃",
	"mall_train_trainorder_yuan":"元",
	"mall_train_trainorder_jijianranyou":"空港建設基金/燃料サーチャージ",
	"mall_train_trainorder_yuanrenbaoxianyuanren":"元／人、保険料20元／人",
	"mall_train_trainorder_checixiangqing":"列車の詳細",
	"modules_selectcity_qingshuruchengshimingcheng":"都市名を入力してください",
	"modules_selectcity_guoji": "国際",
	"modules_selectcity_guonei": "国内",
	"modules_selectcity_diqu":"範囲",
	"modules_selectcity_chezhan":"駅",
	"modules_selectcity_remen":"人気",
	"modules_webmap_dingwei":"ポジショニング",
	"modules_webmap_wodebeizhu":"私のノート",
	"modules_webmap_wodebiaoji":"私のマーク",
	"order_flight_flightdetail_di":"第",
	"order_flight_flightdetail_cheng":"回",
	"order_flight_flightdetail_yueri":"MM月DD日",
	"order_flight_flightdetail_tuigaiguize":"変更・キャンセル規則",
	"order_flight_flightorderinfo_dancheng":"片道",
	"order_flight_flightorderinfo_weibeizhengce":"ポリシー違反",
	"order_flight_flightorderinfo_gongxiang":"コードシェア",
	"order_flight_flightorderinfo_nianyueri":"YYYY年M月DD日 ddd",
	"order_flight_flightorderinfo_tuigaiguize":"変更・キャンセル規則",
	"order_flight_flightorderinfo_yiquxiao":"キャンセルしました",
	"order_flight_flightorderinfo_weibeizhengceyuanyin":"ポリシー違反の理由：{0}",
	"order_flight_flightorderinfo_weibeixiangqing": "违背详情：",
	"order_flight_flightorderinfo_quchuli":"処理します",
	"order_flight_flightorderinfo_details":"详情",
	"order_flight_flightorderinfo_fuhezhengcedingdanshenpi":"ポリシーに準拠した注文を承認する",
	"order_flight_flightorderinfo_mingxi": "明細",
	"order_flight_flightorderinfo_gaiqian":"変更",
	"order_flight_flightorderinfo_tuipiao":"キャンセル",
	"order_flight_flightorderinfo_quxiaotuipiao":"払い戻しを取り消し",
	"order_flight_flightorderinfo_quxiaogaiqian":"変更を取り消し",
	"order_flight_flightorderinfo_quxiaodingdan":"注文をキャンセルする",
	"order_flight_flightorderinfo_shenpi":"承認",
	"order_flight_flightorderinfo_shenqingren":"申請者：{0}",
	"order_flight_flightorderinfo_gaiqianren":"変更担当：{0}",
	"order_flight_flightorderinfo_gaiqianyuanyin":"変更理由：{0}",
	"order_flight_flightorderinfo_xiangqingyuanyin":"詳細理由：{0}",
	"order_flight_flightorderinfo_jiazaizhong":"読み込んでいます...",
	"order_flight_flightorderinfo_yunxutuipiao":"キャンセル可能",
	"order_flight_flightorderinfo_jujuetuipiao":"キャンセル拒否",
	"order_flight_flightorderinfo_yunxugaiqian":"変更可能",
	"order_flight_flightorderinfo_jujuegaiqian":"変更拒否",
	"order_flight_flightorderinfo_shenpitongguo":"承認する",
	"order_flight_flightorderinfo_shenpijujue":"承認を拒否します",
	"order_hotel_hoteldetail_wan":"泊",
	"order_hotel_hoteldetail_tuigaixiangqing":"変更・キャンセル規則",
	"order_hotel_hoteldetail_ri":"日曜日",
	"order_hotel_hoteldetail_yi":"月曜日",
	"order_hotel_hoteldetail_er":"火曜日",
	"order_hotel_hoteldetail_san":"水曜日",
	"order_hotel_hoteldetail_si":"木曜日",
	"order_hotel_hoteldetail_wu":"金曜日",
	"order_hotel_hoteldetail_liu":"土曜日",
	"order_hotel_hoteldetail_zhou":"週",
	"order_hotel_hoteldetail_wuzao":"朝食なし",
	"order_hotel_hotelorderinfo_yueri":"MM月DD日",
	"order_hotel_hotelorderinfo_jian": "间",
	"order_hotel_hotelorderinfo_wan":"泊",
	"order_hotel_hotelorderinfo_weibeizhengce":"ポリシー違反",
	"order_hotel_hotelorderinfo_jiudianxiangqing":"ホテルの詳細",
	"order_hotel_hotelorderinfo_tuigaiguize":"変更・キャンセル規則",
	"order_hotel_hotelorderinfo_yiquxiao":"キャンセルしました",
	"order_hotel_hotelorderinfo_wozhidaoliao":"わかりました",
	"order_hotel_hotelorderinfo_weibeizhengceyuanyin":"ポリシー違反の理由：",
	"order_hotel_hotelorderinfo_quchuli":"処理します",
	"order_hotel_hotelorderinfo_fuhezhengcedingdanshenpi":"ポリシーに準拠した注文を承認する",
	"order_hotel_hotelorderinfo_mingxi": "明細",
	"order_hotel_hotelorderinfo_shenqingtuifang":"チェックアウトに申し込む",
	"order_hotel_hotelorderinfo_quxiaotuifang":"チェックアウトを取り消し",
	"order_hotel_hotelorderinfo_quxiaodingdan":"注文をキャンセルする",
	"order_hotel_hotelorderinfo_shenpi":"承認",
	"order_hotel_hotelorderinfo_shenqingren":"申請者：{0}",
	"order_hotel_hotelorderinfo_gaiqianren":"変更担当：{0}",
	"order_hotel_hotelorderinfo_gaiqianyuanyin":"変更理由：{0}",
	"order_hotel_hotelorderinfo_wuzao":"朝食なし",
	"order_orderInfo_yunxutuipiao": "キャンセルを許可する",
	"order_orderInfo_jujuetuipiao": "キャンセルはお断りしております",
	"order_orderInfo_yunxugaiqian": "変更を許可する",
	"order_orderInfo_jujuegaiqian": "変更を拒否する",
	"order_orderInfo_shenpitongguo": "決裁が通る",
	"order_orderInfo_shenpijujue": "決裁拒否",
	"order_orderInfo_tuipiaoren": "キャンセル者",
	"order_orderInfo_tuipiaoyuanyin": "キャンセルの原因",
	"order_orderInfo_gaiqianren": "変更者",
	"order_orderInfo_gaiqianyuanyin": "変更の理由",
	"order_orderInfo_chuxingren": "通行人を出す",
	"order_orderInfo_chuxingmudi": "旅の目的",
	"order_orderdetails_dingdanxiangqing":"注文詳細",
	"order_orderdetails_dingdanhao":"注文番号：{0}",
	"order_orderdetails_ruzhurenxinxi":"居住者情報",
	"order_orderdetails_chuhangrenxinxi":"旅行者情報",
	"order_orderdetails_shouji":"携帯電話",
	"order_orderdetails_shenfenzheng": "IDカード",
	"order_orderdetails_shanglvxinxi":"出張情報",
	"order_orderdetails_chengbenzhongxin":"コストセンター",
	"order_orderdetails_chalvmudi":"旅行の目的",
	"order_orderdetails_chuchaishiyou": "出張の理由",
	"order_orderdetails_xiangmudaima":"プロジェクトコード",
	"order_orderdetails_lianxiren":"連絡先",
	"order_orderdetails_xingming":"名前",
	"order_orderdetails_youxiang":"メールボックス",
	"order_orderdetails_xuqiubeizhu":"デマンドノート",
	"order_orderdetails_fujianxinxi": "添付ファイル情報です",
	"order_orderdetails_fujianmingcheng": "添付ファイル名です",
	"order_orderdetails_caozuo":"操作します",
	"order_orderdetails_w": "无",
	"order_orderdetails_koukuanshuoming":"お支払い説明",
	"order_orderdetails_hgjndfkfsjhysqhkcffr":"お支払い方法に応じて事前承認または客室料金の差し引きを行いますので、ご注文が確定しない場合は事前承認を取り消すか、お支払い口座に全額返金いたします。 ご注文確定後のキャンセル・変更はできません。チェックインしない場合は初日の宿泊料金、早めの退店の場合は早めのご出発日の料金が発生します。",
	"order_orderdetails_tebietishi":"ヒント！",
	"order_orderdetails_gjddrzsjwtfbzjssjwrt":"ホテルのチェックイン時間は14:00で、標準のチェックアウト時間は12:00です。 アーリーチェックインやレイトチェックアウトなど、必要に応じて一定の料金がかかります。",
	"order_orderdetails_zongji":"合計：",
	"order_orderdetails_mingxi":"明細",
	"order_orderdetails_feiyongmingxi":"料金の明細",
	"order_orderdetails_baoxianfei":"保険料金",
	"order_orderdetails_fuwufei":"サービス料金",
	"order_orderdetails_zonge":"総額：",
	"order_orderdetails_tuigaiguize":"変更・キャンセル規則",
	"order_orderdetails_ri":"日曜日",
	"order_orderdetails_yi":"月曜日",
	"order_orderdetails_er":"火曜日",
	"order_orderdetails_san":"水曜日",
	"order_orderdetails_si":"木曜日",
	"order_orderdetails_liu":"土曜日",
	"order_orderdetails_zhou":"週",
	"order_orderlist_wodedingdan":"私の注文",
	"order_orderlist_meiyougengduoliao":"以上です。",
	"order_orderlist_yudingshijian":"予約時間",
	"order_orderlist_weibeizhengce":"ポリシー違反",
	"order_orderlist_fuhezhengce":"ポリシーに準拠",
	"order_orderlist_chufa":"出発",
	"order_orderlist_zhi":"まで",
	"order_orderlist_wei":"は",
	"order_orderlist_yuding":"予約",
	"order_orderlist_yueri":"MM月DD日",
	"order_orderlist_jipiao":"航空券",
	"order_orderlist_jiudian":"ホテル",
	"order_orderlist_huoche":"列車チケット",
	"order_orderlist_zuche":"タクシーに乗る",
	"order_train_traindetail_di":"第",
	"order_train_traindetail_cheng":"回",
	"order_train_traindetail_yueri":"MM月DD日",
	"order_train_traindetail_tuigaiguize":"変更・キャンセル規則",
	"order_train_trainorderinfo_dancheng":"片道",
	"order_train_trainorderinfo_weibeizhengce":"ポリシー違反",
	"order_train_trainorderinfo_gongxiang":"コードシェア",
	"order_train_trainorderinfo_jianpiaokou":"改札口",
	"order_train_trainorderinfo_zhida":"直行",
	"order_train_trainorderinfo_zongyongshi":"合計時間",
	"order_train_trainorderinfo_nianyueri":"YYYY年M月DD日ddd",
	"order_train_trainorderinfo_tuigaiguize":"変更・キャンセル規則",
	"order_train_trainorderinfo_yiquxiao":"キャンセルしました",
	"order_train_trainorderinfo_tuipiaoshuoming":"払い戻しの説明",
	"order_train_trainorderinfo_dgcgwqpqfcqsjdyfzkjr":"1.購入が成功し、チケットが収集されず、出発までの時間が35分を超える場合は、「私の注文」の中で、列車の注文をクリックして、プロンプトに従って払い戻しを申請できます。出発前15日以内の払い戻しの場合、鉄道局はチケットの払い戻し料金を請求します。",
	"order_train_trainorderinfo_dgcgyqphfcqsjxyfzxnz":"2.購入が成功し、チケットが回収された場合、または出発までの時間が35分未満の場合は、チケットの購入時に使用したの有効な乗客IDと列車のチケットを持参し、鉄道駅の窓口に移動して、出発前に払い戻しを処理する必要があります。",
	"order_train_trainorderinfo_gaiqianshuoming":"変更説明",
	"order_train_trainorderinfo_wqzzpqlfcsjdyfzkgqdy":"1.紙のチケットを受け取らず、出発までの時間が35分を超える場合は、元のチケット料金以下の列車の数を変更できます。 オンラインで変更できないその他の場合は、出発前に駅の窓口に行ってください。",
	"order_train_trainorderinfo_kcqxsyskgqysqndcckcq":"2.運転前の48時間以上、プレセール期間中に車の数を変更することができます。 運転の48時間以内であれば、当日の24:00までに任意の数の列車にチケットを変更でき、チケットの翌日以降はチケットを変更できません。",
	"order_train_trainorderinfo_xcppjdyycpdthcédcébf":"3.新しいチケットの運賃が元のチケットよりも低い場合、差額は返金され、差額に対して返金料金が請求され、現在の返金料金基準が実施されます。",
	"order_train_trainorderinfo_wozhidaoliao":"分かりました",
	"order_train_trainorderinfo_mingxi": "明細",
	"order_train_trainorderinfo_weibeizhengceyuanyin":"ポリシー違反の理由：{0}",
	"order_train_trainorderinfo_quchuli":"処理します",
	"order_train_trainorderinfo_fuhezhengcedingdanshenpi":"ポリシーに準拠した注文を承認する",
	"order_train_trainorderinfo_gaiqian":"変更",
	"order_train_trainorderinfo_tuipiao":"キャンセル",
	"order_train_trainorderinfo_quxiaotuipiao":"払い戻しを取り消し",
	"order_train_trainorderinfo_quxiaogaiqian":"変更を取り消し",
	"order_train_trainorderinfo_quxiaodingdan":"注文をキャンセルする",
	"order_train_trainorderinfo_shenpi":"承認",
	"order_train_trainorderinfo_shenqingren":"申請者：{0}",
	"order_train_trainorderinfo_gaiqianren":"変更担当：{0}",
	"order_train_trainorderinfo_gaiqianyuanyin":"変更理由：{0}",
	"order_train_trainorderinfo_xiangqingyuanyin":"詳細理由：{0}",
	"system_newaddress_shezhimorendizhi":"デフォルトのアドレスを設定する",
	"system_newaddress_shanchu":"削除",
	"system_about_about_lichengshanglv":"力程ビジネストラベル",
	"system_approvalset_provisionalauthorization_linshishenpishouquan":"一時的な承認権利を与える",
	"system_approvalset_provisionalauthorization_qingxuanze":"選んでください",
	"system_approvalset_provisionalauthorization_shouquanyuangong":"認定従業員",
	"system_approvalset_provisionalauthorization_kaishiriqi":"開始日",
	"system_approvalset_provisionalauthorization_xuanzeshijian":"選考期間",
	"system_approvalset_provisionalauthorization_jiezhishijian":"締め切り：",
	"system_approvalset_provisionalauthorization_shouquanshichang":"許可された時間",
	"system_approvalset_provisionalauthorization_xiaoshi":"時",
	"system_approvalset_provisionalauthorization_tian":"日",
	"system_approvalset_provisionalauthorization_shi":"時",
	"system_approvalset_list_baocun":"セーブ",
	"system_approvalset_list_shouquanliebiao":"承認リスト",
	"system_approvalset_list_yijianqingchu":"ワンクリック削除",
	"system_approvalset_list_yiguoqi":"期限切れ",
	"system_approvalset_list_shouquanzhong":"権限を授けています",
	"system_approvalset_list_quxiaoxiugai":"変更を取り消し",
	"system_approvalset_list_qingxuanzeshouquanyuangong":"権限授けされた従業員を選択してください",
	"system_autoupdate_autoupdate_faxianxinbanben":"新しいバージョンが見つかりました",
	"system_autoupdate_autoupdate_xinzeng":"。追加",
	"system_autoupdate_autoupdate_lijigengxin":"すぐに更新",
	"system_configinfo_configinfo_baocun":"セーブ",
	"system_configinfo_configinfo_peizhiguanli":"構成管理",
	"system_configinfo_configinfo_youxiang":"メールボックス",
	"system_configinfo_configinfo_weixin":"WeChat",
	"system_configinfo_configinfo_daishenpi":"承認待ち",
	"system_configinfo_configinfo_daiqueren":"確認待ち",
	"system_configinfo_configinfo_daizhifu":"お支払い待ち",
	"system_configinfo_configinfo_daichuli":"処理待ち",
	"system_configinfo_configinfo_yiwancheng":"完了",
	"system_configinfo_configinfo_baocunchenggong":"セーブ成功",
	"system_download_download_banbenhao":"バージョン番号：V1.16",
	"system_download_download_daxiao":"サイズ：8.75MB",
	"system_download_download_jieshao":"紹介",
	"system_download_download_yingyongjieshao":"アプリケーションの紹介",
	"system_download_download_slcglqxdqyslglxtykqd":"このアプリは、力程の下にある企業の出張管理システムであり、強力なリソース、高度なテクノロジー、高品質のサービス、専門的な管理に依存して、多くの企業が出張、予約、承認の承認手続きを最適化できるよう支援しています。",
	"system_download_download_yonghukeyitongguo":"ユーザーは、APPシステムを介して、航空券、ホテル、電車のチケットの問い合わせ、予約、承認などのサービスを迅速に実行し、旅行管理をインテリジェントにすることができるため、ユーザーはお金を借りたり、資金を前払いしたり、出張について報告したりすることがなく、ユーザーの旅行満足度が向上します。 これは、企業が消費コストを削減し、金銭的償還プロセスを簡素化し、運用効率を向上させるのに本当に役立ちます。",
	"system_download_download_xtksdjhjpjdhcpdcxyds":"",
	"system_download_download_zhuyaogongneng":"主な機能",
	"system_download_download_àcsrqqfsjdxxcxbydjpj":"1.都市、日付、出発時刻、その他の情報に応じて、航空券、ホテル、電車のチケットを照会して予約します。",
	"system_download_download_qyyjdpwxygdkjkdphsxy":"2.企業の支払いは毎月決済されます。チケット予約（従業員はまえばらいなしでチケットを予約できます）およびクレジットスタッフ管理。",
	"system_download_download_qingsongchakanguanlidingdanyijiantuipiaogaiqian":"3.注文を簡単に表示および管理し、ワンクリックで払い戻しと変更を行います。",
	"system_download_download_zcqydcbgkszydgczlhgk":"4.企業の差分標準制御設定、予約プロセス中の柔軟な制御をサポートします。 企業が旅行ポリシーをより適切に実装し、コストを節約できるように支援します。",
	"system_feedback_feedback_fankuileixing":"フィードバックタイプ",
	"system_feedback_feedback_fankuineirong":"フィードバックコンテンツ",
	"system_feedback_feedback_wltgwmdfwhzlwmwntgfw":"サービスと品質を向上させるために、サービスに関する苦情や提案のための専用チャネルを提供し、できるだけ早く大手BOSSにフィードバックします。",
	"system_feedback_feedback_shangchuanzhaopian":"写真をアップロードする",
	"system_feedback_feedback_shangchuantupianshuomingkeyigengfangbianwomenlijienindexuqiuo":"写真の説明をアップロードすると、お客様のニーズを理解しやすくなります",
	"system_feedback_feedback_yibianwomengeininhuifu":"返信できるように",
	"system_feedback_feedback_shoujihao":"電話番号：",
	"system_feedback_feedback_qitalianxifangshiyouxiang":"その他の連絡先情報（メール/ QQ ...）",
	"system_feedback_feedback_qita":"その他",
	"system_feedback_feedback_tijiao":"提出",
	"system_feedback_feedback_yijianfankui":"フィードバック",
	"system_feedback_feedback_shijuetiyan":"视觉体验",
	"system_feedback_feedback_caozuotiyan":"操作体验",
	"system_feedback_feedback_zhengzaishangchuan":"アップロード中",
	"system_feedback_feedback_shangchuanchenggong":"アップロード成功",
	"system_feedback_feedback_shangchuanshibai":"アップロードに失敗しました",
	"system_feedback_feedback_qingtianxienindebaoguiyijianhuoshangchuanzhaopian":"貴重なコメントを記入するか、写真をアップロードしてください",
	"system_feedback_feedback_tijiaochenggongganxienindefankui":"送信は成功しました。フィードバックをありがとうございます",
	"system_mall_addinvoice_shanchu":"削除",
	"system_mall_addtraveller_shanchu":"削除",
	"system_mall_modules_travelername_xingmingxuyuxiedaichuhangdezhengjianyizhifouzehuiyingxianghangcheng":"名前は旅行書類と一致している必要があります。一致していない場合、旅程に影響します",
	"system_mall_modules_travelername_tianxiexuzhi":"記入注意事項",
	"system_mall_modules_travelername_yitianxieshuoming":"記入説明",
	"system_mall_modules_travelername_chengkexingmingxuyudengjisuochizhengjianshangdemingziyizhi":"1.乗客の名前は、搭乗証明書の名前と同じである必要があります。",
	"system_mall_modules_travelername_wqbslchqqblhjsrqzsbz":"2.スムーズな旅行を確保するために、旅行の終了日が証明書の有効期間より少なくとも6か月早いことを確認し、真の有効な証明書番号を入力することを確認してください。注文の送信後、変更することはできません。",
	"system_mall_modules_travelername_erxinbanhuzhao":"2.新しいパスポート",
	"system_mall_modules_travelername_sanjiubanhuzhao":"3.古いパスポート",
	"system_mall_modules_travelername_sigangaotonghangzheng":"4.香港とマカオパス",
	"system_mall_modules_travelername_wutaiwantonghangzheng":"5.台湾パス",
	"system_mall_modules_travelername_liutaibaozheng":"6.台湾同胞カード",
	"system_mall_oftenpassenger_gongsichangke":"会社常連",
	"system_mall_oftenpassenger_gerenchangke":"個人の常連",
	"system_messagenotify_messagenotify_gong":"合計",
	"system_messagenotify_messagenotify_tiaoxiaoxi":"つのメッセージ",
	"system_messagenotify_messagenotify_weiduxiaoxi":"未読メッセージ",
	"system_messagenotify_messagenotify_yiduxiaoxi":"既読メッセージ",
	"system_messagenotify_messagenotify_zanwuxiaoxi":"メッセージはありません",
	"system_messagenotify_messagenotify_xiaoxitongzhi":"お知らせ",
	"system_messagenotify_messagenotify_quanbuxiaoxi":"すべてのメッセージ",
	"system_messagenotify_messagenotify_xitongtongzhi":"システム通知",
	"system_messagenotify_messagenotify_xiaoxitixing":"メッセージ通知",
	"system_messagenotify_notifyitem_xitongtongzhi":"システム通知",
	"system_messagenotify_notifyitem_xiaoxitixing":"メッセージ通知",
	"system_messagenotify_notifyitem_ganggang":"只今",
	"system_messagenotify_notifyitem_shanchu":"削除",
	"system_modules_calendar_zhongzhi":"リセット",
	"system_modules_calendar_ri":"日曜日",
	"system_modules_calendar_yi":"月曜日",
	"system_modules_calendar_er":"火曜日",
	"system_modules_calendar_san":"水曜日",
	"system_modules_calendar_si":"木曜日",
	"system_modules_calendar_wu":"金曜日",
	"system_modules_calendar_liu":"土曜日",
	"system_modules_calendar_yuandan":"元日",
	"system_modules_calendar_qingmingjie":"チンミンフェスティバル",
	"system_modules_calendar_laodongjie":"メーデー",
	"system_modules_calendar_guoqingjie":"国慶節",
	"system_modules_calendar_chuxi":"大晦日",
	"system_modules_calendar_chunjie":"春節",
	"system_modules_calendar_duanwujie":"端午の節句",
	"system_modules_calendar_zhongqiujie":"中秋節",
	"system_user_account_account_jiebang":"バインドを解除する",
	"system_user_businessregister_qiyeyonghuzhuce":"エンタープライズユーザー登録",
	"system_user_businessregister_ruguigongsiyishilichengshanglvqianyueqiye":"御社がすでに力程ビジネストラベルlの契約企業である場合、旅行マネージャーに連絡してアカウントを取得してください。繰り返し登録しないでください。",
	"system_user_businessregister_qinglianxinindechalvfuzerenhuoquzhanghaowuzhongfuzhuce": "请联系您的差旅负责人获取账号，勿重复注册",
	"system_user_businessregister_qingshuruninqiyemingcheng":"御社の会社名を入力してください",
	"system_user_businessregister_qiyemingcheng":"会社名",
	"system_user_businessregister_shoujihaohuoyouxiangzhuce":"携帯電話番号またはメール登録",
	"system_user_businessregister_shoujihao":"電話番号",
	"system_user_businessregister_qingshuruyanzhengma":"確認コードを入力してください",
	"system_user_businessregister_yanzhengma":"検証コード",
	"system_user_businessregister_qingshuruguiqiyesuoshuhangye":"御社の業界を入力してください",
	"system_user_businessregister_qiyehangye":"エンタープライズ業界",
	"system_user_businessregister_qingshuruguiqiyediqu":"御社のビジネスエリアを入力してください",
	"system_user_businessregister_qiyediqu":"ビジネスエリア",
	"system_user_businessregister_qingtianxielianxirenxingming":"連絡先名を入力してください",
	"system_user_businessregister_lianxiren":"連絡先",
	"system_user_businessregister_zhucezhanghao":"アカウント登録",
	"system_user_businessregister_qingshezhidenglumima":"ログインパスワードを設定してください",
	"system_user_businessregister_denglumima":"ログインパスワード",
	"system_user_businessregister_zaicishurumima":"パスワードをもう一度入力してください",
	"system_user_businessregister_querenmima":"パスワードを確認",
	"system_user_businessregister_tongyi":"同意する",
	"system_user_businessregister_fuwuxieyi":"サービス契約",
	"system_user_businessregister_xiayibuyanzheng":"次へ、確認します",
	"system_user_businessregister_wancheng":"完成",
	"system_user_businessregister_ruzhucechuxianwenti":"登録に問題がある場合",
	"system_user_businessregister_qingboda": "カスタマーサービスに電話して回答してください",
	"system_user_businessregister_lianxikefuweinijieda":"",
	"system_user_businessregister_zhuce":"登録",
	"system_user_businessregister_gongsimingchengbunengkong":"会社名を空にすることはできません",
	"system_user_businessregister_dangqianshoujihaoyibeizhuce":"現在の携帯電話番号が登録されています",
	"system_user_main_peizhiguanli":"構成管理",
	"system_user_modules_authorizat_qiyezhanghaoyouxiangshoujihao":"企業アカウント/メール/電話番号",
	"system_user_modules_authorizat_qingshuruzhanghu":"アカウントを入力してください",
	"system_user_modules_authorizat_buqufendaxiaoxie":"大文字と小文字を区別しません",
	"system_user_modules_authorizat_qingshuruyanzhengma":"確認コードを入力してください",
	"system_user_modules_authorizat_lijibangding":"今すぐバインド",
	"system_user_modules_authorizat_lijizhuce":"今すぐサインアップ",
	"system_user_modules_authorizat_zhanghaobangding":"アカウントのバインド",
	"system_user_modules_authorizat_shoujiyanzhengbangding":"携帯電話検証バインディング",
	"system_user_modules_ordinary_lijizhuce":"今すぐサインアップ",
	"system_user_modules_ordinary_denglu":"ログインする",
	"system_user_modules_ordinary_xiugaichushimima":"初期パスワードを変更する",
	"system_user_modules_password_shezhimima":"パスワードを設定してください",
	"system_user_modules_password_xiacidenglutixingwo":"今回のログインに提示",
	"user_resetpwd_mobilevalidate_yanzhengguize":"検証ルール",
	"user_resetpwd_verifyidentity_zhaohuimima":"パスワードを取り返す",
	"user_resetpwd_verifyidentity_dengluming":"ログイン名",
	"user_resetpwd_verifyidentity_zhucehuobangdingdeshoujihaohuoyouxiang":"登録またはバインドされた携帯電話番号または電子メール",
	"user_resetpwd_verifyidentity_haiwaishoujiqinganguojiadaimashoujihaomadegeshishururu":"海外の携帯電話の場合は、「国コード-携帯電話番号」の形式を入力してください：79-66666666",
  "user_resetpwd_verifyidentity_xiayibu":"次へ",
  user:{
    companyName:'力程ビジネストラベル'
  },
  router:{
    home:'トップページ',
    trip:'旅程',
    my:'マイ',
  },
  bill:{
    myOrder:'私の注文'
  },
  mall: {
    OnBusiness:'公務出張',
    OnPersonal:'個人予約',
    btriprule:'旅行のルール',
    demandorder:'デマンドリスト',
    allprice:'ノーマルエコノミー',
    discount:'割',
    GivenName:'名（ローマ字）',
    Surname:'姓（ローマ字）',
    selectedseat:'席指定済み',
    noselectseat:'席指定',
    takeOff:'離陸',
    FillInfo:'入力注意事項',
    ExpiryDate:'有効期限',
    StartTime:'開始時間',
    EndTime:'終了時間',
    ToProcessDate:'出発日',
    backTracking:'帰り日',
    sharing:'コードシェア',
    AirplaneModelTxt:'機材',
    ticketfeeFloat:'表示金額は、燃料サーチャージを含まていません',
    peopleTypeExplain:'小児、乳児について',
    bookingTicketExplain:'子供/幼児のチケットを予約する必要がある場合は、カスタマーサービスにお問い合わせください。',
    onlySeeDirect:'直行便のみを見る',
    hiddenSharedFlight:'コードシェアを隠す',
    ActualCarrier:'実際運送先',
    stayTxt:'滞在',
    turnTxt:'乗り継ぎ',
    priceRemarks:'以下の料金は、「大人1名または子供1名または幼児1名」の1人あたりの平均価格です。',
    AgreementPrice:'ビジネスの推奨',
    tax:'税金',
    trainHolderKeyWords:'国内列車チケット',
    bookingRemarks:'一度に予約できる乗客は最大5人までです',
    beginTxt:'始まり',
    passTxt:'経由',
    endTxt:'終わり',
    StandingOrder:'駅の順番',
    stationName:'駅名',
    arrivalTimeTxt:'到着時間',
    departTimeTxt:'出発時間',
    departDate:'出発日',
    arrivalDate:'到着日',
    hotelHolderKeyWords:'キーワード/ホテル名などを入力してください。',
    HotelRemarks:'5部屋以上の予約はご遠慮ください。チェックイン日は20泊を超えないようにしてください。 特別予約については、カスタマーサービスまでお問い合わせください。',
    TrainRemarks:'注意：チケットの購入時間は午前7時30分から午後22時30分までです。 チケットの購入、変更、払い戻しは、発車の30分前までに行う必要があります。 同日以内の旅程は10分以内、24時間を超える旅程は25分以内にお支払いください。',
    NoTrainSearch:'現時点では列車サーチは提供されていません',
    mapTxt:'地図ナビゲーション',
    detailsOrFacilities:'詳細/施設',
    noSooner:'朝食なし',
    breakfast:'朝食',
    breakfastTxt:'朝食付き',
    noCancellation:'キャンセル不可',
		timeToCancel:'期間限定キャンセル',
		withWindow:"既存のウィンドウ",
    RoomsTxt:'部屋数',
    hotelUnit:'泊',
    checkInTxt:'チェックイン',
    checkOutTxt:'チェックアウト',
    checkInDate:'チェックイン日',
    checkOutDate:'チェックアウト日',
    Frequenter:'常連客',
    Temporary:'臨時客',
    TemporaryInformation:'臨時客情報',
    addFrequenter:'常連客を追加',
    addTemporary:'臨時客を追加',
    TravelStandard:'旅行基準',
    hightToLow:'高から安',
    lowToHight:'安から高',
    morningToNight:'早いから遅い',
    nightToMorning:'遅いから早い',
    starLevelTxt:'星評価',
    filtrateTxt:'絞り込み',
    timeTxt:'時間',
    fromTo:'から',
    portion:'分',
    contactNumber:'連絡先番号',
    conformToRules:'ポリシーに準拠',
    breakToRules:'ルールに違反する',
    unlimited:'無制限',
    beforeDay:'前日',
    afterDay:'翌日',
    adequateTxt:'',
    Remaining:'わずか',
    taxesTxt:'税金',
    BackTorule:'変更．キャンセルルール',
    trainamendrule:'発車時刻の15日以上前（除く）の払い戻しについては、払い戻し料金は請求されません。 発車時刻の48時間以上の場合、料金の5％の払い戻し料金が請求されます。発車時刻の24時間以上、48時間未満の場合、料金の10％の払い戻し料金が払い戻し時に請求されます。発車時刻の24時間以内の場合は、料金の20％返金手数料がかかります。',
    booking:'注文する',
    onlinePay:'オンラインで支払う',
    departTxt:'出発',
    arrivalTxt:'到着',
    sheet:'枚',
    NoTicket:'チケットなし',
    orderFilltitle:'注文入力',
    tripInfosTitle:'旅行者情報',
    BookingInformation:'予約通知',
    tripInfosRemarks:'スムーズに旅行するために、旅行書類と一致する項目を必ず記入してください',
    addTraveller:'乗客を追加',
    UserName:'氏名',
    contactInfosTitle:'代表者情報',
    RemarkInfosTitle:'付注情報',
    contacts:'代表者',
    Phone:'携帯電話',
    Email:'電子メール',
    InstructTitle:'お支払い説明',
    InstructContent:'お支払い方法に応じて事前承認または客室料金の差し引きを行いますので、ご注文が確定しない場合は事前承認を取り消すか、お支払い口座に全額返金いたします。 ご注文確定後のキャンセル・変更はできません。チェックインしない場合は初日の宿泊料金、早めの退店の場合は早めのご出発日の料金が発生します。',
    SpecialTipsTitle:'特記事項',
    SpecialTipsContent:'ホテルのチェックイン時間は14:00で、標準のチェックアウト時間は12:00です。 アーリーチェックインやレイトチェックアウトなど、必要に応じて一定の料金がかかります。',
    travelInformationTitle:'旅行情報',
    CostCenter:'コストセンター',
    TravelPurpose:'旅行の目的',
    ProjectCode:'プロジェクトコード',
    contraryReason:'違反の理由',
    ViolateTravelRules:'旅行ルールに違反',
    SpecialRequirement:'特別ニーズ',
    SpecialRequirementTips:'特別ニーズ入力',
    specialRequirementContent:'私たちはあなたの特別な要件を調整するために最善を尽くします。 満足できない場合は別途お知らせいたしませんので、ご容赦ください。',
    otherRequirement:'その他の要求',
    consentAgreement:'[送信]をクリックして、読んで同意したことを示します',
    importantTerms:'予約手順と重要な条件',
    BookingHint:'グリーン環境保護のデフォルトの電子契約をサポートするために、紙の契約に署名する必要がある場合は、カスタマーサービスに連絡してください。',
    CostDetails:'料金の詳細',
    payTotalPrice:'支払総額',
    totalPrice:'総額',
    roomUnit:'部屋',
    nightUnit:'泊',
    peopleUnit:'人',
    details:'詳細',
    CustomerService:'カスタマーサービスにお問い合わせください',
    SubmissionOrPayment:'送信/支払い',
    frequentlnformationTitle:'乗客情報',
    TravellerTitle:'乗客名',
    EnglishName:'英語名',
    LastName:'姓（ローマ字）',
    firstName:'名（ローマ字）',
    NameOrIdCardTips:'スムーズな旅行を確実にするために、旅行名が証明書と一致していることを確認してください。',
    CertificateInformatTitle:'証明書情報',
    ExpireDate:'証明書の有効期間',
    otherInfosTitle:'その他の情報',
    Sex:'性別',
    Birthday:'生年月日',
    Nationality:'国籍',
    optionalCard:'国籍乗客カード（オプション）',
    reminderInfos:'スムーズにご旅行いただけるよう、ご旅行の終了日が書類の有効期間より6ヶ月以上前であることを確認し、有効な書類番号をご記入ください。ご注文後の変更はできません。',
    addOrEditTraveller:'乗客を追加',
    AllOrder:'すべての注文',
    orderStatus:'注文の状況',
    departTime:'出発時間',
    orderDetail:'注文詳細',
    CancelOrder:'注文をキャンセルする',
    CancelRefund:'払い戻しをキャンセルする',
    CancelChange:'変更をキャンセルする',
    ApprovalRefused:'承認を拒否する',
    ApproveSucc:'承認を認める',
    PayNow:'すぐに支払う',
    Refund:'払い戻し',
    RefundHotel:'チェックアウト',
    RefundGroup:'グループを離れる',
    Change:'変更',
    SubmitOrder:'注文を送信',
    PriceDetail:'価格の詳細',
    CheckOrderProgress:'注文の進捗状況を検査',
    flightInformation:'フライト情報',
    orderNumber:'注文番号',
    BookingTime:'予約時間',
    First:'第',
    Journey:'回',
    few:'部屋',
    Level:'級',
    BackToChangeTips:'最終的な金額は審査の対象となります。ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。',
    pleaseChoose:'選んでください',
    ThePassengers:'ｘｘｘの方',
    Transfer:'経由',
    Flight:'フライト',
    RefundRoomsDate:'チェックイン／チェックアウト',
    TheReason:'の理由',
    TheTrain:'の列車',
    hour:'時間',
    minute:'分',
    Gym:'ジム',
    district:'行政区',
    business:'ビジネスエリア',
    ThePassengerInformation:'乗客情報',
    NewTrainInformation:'新しい列車情報',
    OriginalTrainInformation:'元の列車情報',
    NewFlightInformation:'新しいフライト情報',
    OriginalFlightInformation:'元のフライト情報',
    NextStep:'次へ',
    ChangeDate:'変更日',
    SelectChangeFlight:'変更対象となるのフライトを選択してください',
    SelectRefundFlight:'払い戻しの対象となるのフライトを選択してください',
    SelectChangeTrain:'変更対象となるの乗客を選択してください',
    SelectRefundTrain:'払い戻しの対象となるの乗客を選択してください',
    SelectRefundHotel:'チェックアウトするホテルを選択してください',
    SelectChangeDate:'変更日を選択してください',
    Department:'部門',
    ApprovalStatus:'承認状況',
    ConfidentialInformation:'証書情報',
    TradeInformation:'取引情報',
    Insurance:'保険',
    Home:'ホーム',
    Stroke:'日程',
    Me:'マイ',
    TravelApproval:'旅行の承認',
    TravelRulesName:'旅行ルール名',
    MinimumPriceBase:'最低価格ベンチマーク',
    RealFlightControl:'リアルタイムのフライトコントロール',
    AdvanceBookingTime:'事前に時間を予約する',
    ClassLimit:'クラス制限',
    SeatClassLimit:'座席クラスの制限',
    AgreementAirlinePriority:'契約航空券優先',
    AgreementHotelPriority:'合議ホテルを優先',
    MaximumAmountConsumption:'消費金額上限',
    ApprovalName:'承認名',
    Other:'その他',
    FirstClassCity:'一次都市',
    SecondaryCity:'二次都市',
    ThreeLevelCity:'三次都市',
    SeatSelectionService:'座席選択サービス',
    Bezel:'窓',
    Aisle:'通路',
    NewContacts:'連絡先を追加',
    AdditionalInvoiceInformation:'領収書情報の追加/編集',
    InvoiceInformation:'領収書情報',
    InvoiceTitle:'領収書の宛名',
    TariffItem:'税番号',
    SetDefaultContacts:'デフォルトの連絡先を設定する',
    ConsigneeAddress:'受信者のアドレス',
    NewCommonAddresses:'頻繁に使用するアドレスを追加する',
    default:'デフォルト',
    City:'都市',
    Address:'アドレス',
    Postcode:'郵便番号',
    AddCommonAddresses:'頻繁に使用するアドレスを追加/編集する',
    DepartureTime:'出発時間',
    Airport:'空港',
    ShippingSpace:'クラス',
    AirlineCompany:'航空会社',
    '150OrLess': '￥150以下',
    '150And300': '￥150-300',
    '300And450': '￥300-450',
    '450And600': '￥450-600',
    '600OrMore': '￥600以上',
    TwoStarsOrLess:'2つ星以下',
    ThreeStar:'3つ星/快適',
    FourStar:'4つ星/高級',
    FivesStar:'5つ星/豪華',
    Apartment:'アパート',
    Inn:'宿',
    FamilyInn:'ファミリーイン',
    YouthHostel:'ユースホステル',
    CoupleHotel:'ラブホテル',
    GardenCourtyard:'中庭',
    SeaView:'海景',
    Farmhouse:'農家',
    HotSpringHotel:'温泉ホテル',
    GolfHotel:'ゴルフホテル',
    Siheyuan:'四合院',
    Villa:'別荘',
    PartyCooking:'パーティークッキング',
    BusinessTtravelHome:'ビジネストラベルホーム',
    LeisureMood:'カジュアルムード',
    SeeDoctor:'病院',
    VacationLeisure:'休暇とレジャー',
    TrainAndLearn:'トレーニングと学習',
    GetTogether:'パーティー',
    HoneymoonTrip:'ハネムーン',
    boutiqueHotel:'ブティックホテル（デザイナーホテル）',
    FreeWifi:'無料のwifi',
    FreeParking:'無料駐車場',
    IndoorPool:'屋内スイミングプール',
    OutdoorPool:'屋外スイミングプール',
    service:'ジム',
    BusinessCenter:'ビジネスセンター',
    MeetingRoom:'会議室',
    HotelRestaurant:'ホテルのレストラン',
    MorningCall:'モーニングコール',
    LuggageStorage:'荷物置き場',
    TwinBed:'ダブルベッド',
    BigBed:'キングベッド',
    FreePickUpService:'無料ピックアップサービス',
    Price:'価格',
    StarLevel:'星評価',
    Specialtie:'特徴',
    Service:'施設サービス',
    DetailsOrFacilities:'詳細/施設',
    HotelDetail:'ホテルの詳細',
    ModelSelection:'機材を選択してください',
    HighSpeedRail:'高速レール（G / C）',
    MotorCar:'動車(D)',
    Ordinary:'普通列車(Z/T/K)',
    DepartureOrArrival:'出発/到着駅',
    Date:'日付',
    Status:'状況',
    OldSystem:'PC版でご覧ください',
    Welcome:'ようこそ',
    PleaseLogIn:'ログインしてください',
    FlightTips:'格安の航空券、快適な旅行',
    HotelTips:'独占滞在、出張専用',
    TrainTips:'ワンクリックライトニングチケット発行',
    TourTips:'注目の特別オファーツアー',
    Invoice:'領収書の宛名',
    InvoiceType:'領収書の種類',
    Identifier:'識別子',
    TicketInquiry:'航空券の検索',
    TrainInquiry:'列車の検索',
    HotelInquiry:'ホテルの検索',
    ConsumerHotline:'カスタマーサービス電話',
    WeChatService:'WeChatカスタマーサービス',
    TravelPolicy:'旅行ポリシー',
    EditData:'情報を編集する',
    RecommendFlight:'推奨航空便',
	voyageinfos: "航路情報です",
	passinfos: "乗客情報です",
    passnum: "乗客数です",
	cabinlevel: "クラスクラスです",
	consumertype: "乗客のタイプです",
	sui: "歳です",
    twosui: "2歳以下です",
    firstairway: "第一志望の航空会社です",
	demandprobtip: "提出に問題がございましたらお問合せ下さい：",
	submit: "提出します",
	remark: "備考です",
	email: "メールボックスです",
	contact: "連絡先です",
	phoneno: "携帯電話番号です",
	contactinfo: "連絡先情報です",
	normal: "普通です",
    student: "学生です",
    newimmigrant: "新しい移民です",
    worker: "労務です",
	adult: "成人です",
    child: "子供です",
    infant: "赤ちゃんです",
	departcity: "出発都市です",
    arrivecity: "都市に到着します",
    departdate: "出発時間です",
    arrivedate: "到着時間です",
	selectdate: "日時をお願いします",
	delete: "削除します",
	addvoyage: "航路を追加します",
	notificationMessageFlight:"お知らせ:ご希望があれば、こちらをクリックして国際航空券に入ることができます。もっと安い国際航空券です。ご旅行のご要望にお応えします：",
	noVoyage:'無満足航程ですか?',
	foundRequirement:'デマンドシートを作成します',
	Hotline: "ホットラインでお問い合わせします。",
    OriginalFlight:'元のフライト',
    More:'もっと',
    MoreInfo:'詳しくは',
    Hidden:'隠す',
    JetFuel:'燃料費を含め',
    Booking:'予約',
    CurrentPosition:'現在位置',
    Room:'部屋',
    SquareMeters:'平方メートル',
    CanLive:'入居可能',
    Floor:'ビール',
    Layer:'階',
    ServiceFee:'サービス料',
    InsurancePremium:'保険料',
    Yuan:'人民元',
    ContactHotel:'ホテルにお問い合わせください',
    After:'後',
    Before:'前',
    For:'は',
    DueTo:'で予約',
    ViolationPolicy:'ポリシー違反',
    CompliancePolicy:'ポリシーに準拠',
    BusinessInformation:'出張情報',
    Within:'以内',
    RefuseReason:'承認付注',
    Against:'に違反しました',
    Policy:'のポリシー',
    DetailedReason:'詳細理由',
    Wait:'待つ',
    Approval:'承認',
    Breach:'違反',
    AirlineAuditStandards:'最新の航空会社の規制に従い、ご不明な点がございましたら、カスタマーサービス番号にお問い合わせください。',
    ConfirmOrder:'注文を確認',
    FlightInformation:'ルート確認',
    Voyage:'ルート',
    DeparturePlace:'出発地点',
    ArrivePlace:'到着地点',
    AddVoyage:'ルート追加',
    PassengersNumbers:'乗客数',
    ShipType:'クラス類別',
    PassengersType:'乗客タイプ',
    ShipCompany:'優先航空会社',
    Remarks:'付注',
    PackUp:'納める',
    Show:'展開',
    DocumentType:'証明書の種類',
    CardNo:'証明書番号',
    InvoiceRole:'領収書の役割',
    BankName:'銀行名',
    BankAccount:'銀行口座',
    RegisteredAddress:'登録住所',
    RegisteredPhone:'登録電話',
    ChangeReason:'変更理由',
    VoucherNumber:'証明書番号',
    CancelReason:'キャンセル理由',
    ChildInfantBooking:'子供と幼児の予約説明',
    boyin:'ボーイング',
    kongke:'エアバス',
    AppropriationBudget:'経費予算',
    Attendance:'参加者の数',
    HostPlace:'会場',
    Destination:'目的地',
    ParticipantsNumber:'参加者の数',
    ActivityBudget:'活動予算',
    AmountPaid:'支払われる金額',
    ConfirmPayment:'支払いを確認する',
    Pay:'支払い',
    PriceTxt:'価額',
	ReserveHint:'現在は非往復便ですが、もしそのうちの一つの便が変働した場合、もう一つの便がキャンセルを処理しなければならない乗客は自分でキャンセル費用を負担しなければなりません。'
  },
  placeholders: {
    UserID:'ユーザー名を入力してください',
    Password:'パスワードを入力してください',
    UserPhone:'携帯番号を入力してください',
    contacts:'連絡先名を入力してください',
    Email:'確認証明書を受け取るために使用されます',
    CostCenter:'コストセンターを選択してください',
    TravelPurpose:'旅行目的を選択してください',
    ProjectCode:'プロジェクトコードを入力してください',
    CauseName:'違反の理由を選択してください',
    CauseDetails:'違反の詳細な理由を記入してください',
    searchTraveller:'名前を入力してください',
    SearchZones:'都市と駅の中国語またはローマ字',
    UserName:'証明書の名前と同じ',
    LastName:'例：張飛、記入：tyou',
    firstName:'例：張飛、記入：hi',
    CardNo:'お持ちの証明書番号',
    Phone:'携帯電話番号を入力してください',
    RecipientAddress:'受信者の住所を入力してください',
    RecipientPostcode:'受信者の郵便番号を入力してください',
    OriginalPassword:'元のパスワードを入力してください',
    NewPassword:'新しいパスワードを入力してください',
    AffirmNewPassword:'パスワードを確認してください',
    CompanyName:'会社名を入力してください',
    SelectCity:'都市を選択してください',
    Industry:'業界を入力してください',
    Account:'電話番号またはメールアドレスを入力してください',
    VerificationCode:'確認コードを入力してください',
    DynamicCode:'動的コードを入力してください',
    RegisterPhone:'携帯電話番号を登録またはバインドしてください！',
    Invoice:'領収書の宛名',
    InvoiceType:'領収書の種類',
    Identifier:'必須：納税者識別番号',
    RefusalCause:'拒否の理由を入力してください',
    CaseInsensitive:'大文字と小文字を区別しません',
    MessageAuthenticationCode:'SMS確認コード',
    DeparturePlace:'出発地点',
    ArrivePlace:'到着地点',
    ContactEmail:'メールアドレスを入力してください',
    Remarks:'付注を入力してください',
    ShipCompany:'優先航空会社',
    BankName:'銀行名',
    BankAccount:'銀行口座',
    RegisteredAddress:'登録住所',
    RegisteredPhone:'登録電話',
    TrainDetailReason:'列車の詳細理由',
    PeopleNumber:'人数を入力してください',
    AppropriationBudget:'予算を入力してください',
    ContactNumber:'連絡先の電話番号を入力してください',
    ContactRemarks:'最も都合の良い連絡時間と方法を教えてください。そして、最も適切な時間に返信させて致します。。',
  },
  system: {
    Customer:'オンラインサービス',
    EmailNotification:'電子メール通知',
    servicePhone:'',
    Company:'力程ビジネストラベル',
    Name:'力程ビジネストラベル',
    contacts:'連絡先',
    HowToCall:'誰もがあなたを何と呼ぶべきですか',
    PerfectInformation:'携帯電話番号を記入してください',
    BindingPhone:'電話をバインド',
    BindingEmail:'メールボックスをバインドする',
    AccountAssociated:'アカウントの関連付け',
    UpdatePassword:'ログインパスワードを変更する',
    Language:'言語',
    Chinese:'中国語',
		English:'英語',
		Japanese:'日本語',
    ExitLogin:'サインアウト',
    WeChat:'WeChat',
    ImmediatelyBinding:'今すぐバインド',
    Password:'パスワード',
    OriginalPassword:'元のパスワード',
    NewPassword:'新しいパスワード',
    AffirmNewPassword:'パスワードを確認する',
    ChangePassword:'パスワードを変更する',
    EditPersonalInformation:'プロファイル編集',
    CompanyName:'会社名',
    Industry:'業界',
    Account:'アカウント',
    VerificationCode:'検証コード',
    DynamicCode:'動的コード',
    RegisterNow:'今すぐ登録',
    Register:'登録',
    UserRegister:'個人登録',
    CompanyRegister:'企業登録',
    ServiceAgreement:'《力程旅行网服务协议》に同意する',
    SendDynamicCode:'動的コードを送信する',
    Sent:'送られた',
    LoginTxt:'ログインする',
    DynamicPasswordLogin:'動的パスワードログイン',
    ForgetPassword:'パスワードを忘れる',
    Integral:'ポイント',
    AllOrders:'すべての注文',
    Obligation:'支払い待ち',
    NotToTravel:'未完成',
    ToApproval:'承認待ち',
    TicketInformation:'チケット情報',
    OrderInformation:'注文情報',
    OrderID:'注文番号',
    TradeID:'取引番号',
    TradeAmount:'注文の合計額',
    CollectingCompany:'支払いを受け取るの会社',
    PaymentWays:'支払方法',
    Payment:'支払う',
    ThePassengerInformation:'乗客情報',
    PassWordLogin:'パスワードログイン',
    CodeLogin:'確認コードログイン',
    Notice:'お知らせ',
    RecentOrders:'最近の旅程',
    Reserved:'予約中',
    CustomerService:'カスタマーサービス',
    Sell:'営業担当',
    ContactUs:'お問い合わせください',
    Call:'呼び',
    ServiceDept:'カスタマーサービス部門',
    MyOrder:'私の注文',
    ApprovalDispose:'承認処理',
    RetrievePwd:'ログインやパスワード取得の為に',
    ElectronicBills:'電子請求書を受け取るの為に',
    ApprovalAccredit:'承認の権利を与える',
    AboutUs:'私たちに関しては',
    TestGetCode:'確認コードを取得する',
    PhoneHint:'有効なバインドされた携帯電話を介してパスワードをリセットできます。',
    EmailHint:'有効なバインドされた電子メールアドレスを介してパスワードをリセットできます。',
    LoginPassword:'ログインパスワード',
    ResetPassword:'パスワードを再設定する',
    EnterAccount:'アカウントを入力してください',
    PhoneVerification:'電話による確認',
    EmailVerification:'電子メールによる確認',
    SetBinding:'バインディングを設定する',
    Input:'入力',
    Effective:'有効な',
    Verify:'検証',
    NextStep:'次へ',
    RemarkString:'変更またキャンセルの時効',
    RefundFee:'キャンセル料',
    Cabinfee:'変更料金（同じクラス）',
    ReimburseInfo:'清算明細',
    BaggageAllowance:'手荷物制限',
    BackChangeRemark:'上記の大人の変更料金またキャンセル料金の規則は参照用であり、実際は航空会社の規則に従います',
    PartRoute:'一部のルート',
    PartHotel:'一部のホテル',
    IsSaveCustomers:'常連客として保存',
    EmployeeRights:'従業員の権限',
    DateGranted:'付与日',
    ExpiryDate:'期限切れ',
    AddApproval:'承認の追加/変更',
    AddApprovals:'承認を追加',
    DownloadInstall:'ダウンロードとインストール',
    TopRightCorner:'右上隅をクリックしてください',
    BrowserOpen:'選択してブラウザで開く',
    CannotDownloaded:'WeChat / QQでアプリをダウンロードできません',
    CompanyProfile:'会社概要',
    CompanyProfileContent:'上海力程（公式ウェブサイト:www.lichengtrip.net）は上海力程票務株式会社と提携しています。本社は上海の長寧区新東方国際ビジネスセンターにあり、カオジアドゥのジンガン寺院やその他のビジネスセンターの近くにあります。 敷地内には、コールセンター、ゼネラルマネージャーズオフィス、ファイナンス部門、チケット決済部門、国際部門、国内カウンターパート部門、カスタマーサービス部門、トレーニング部門、コマース部門、オペレーションセンターなどの対応部門があります。 上海で幅広い販売、大規模なサービス、強力な総合力を備えた大規模な民間航空サービス会社です。',
    FutureProspects:'今後の展望',
    FutureProspectsContent:'インターネット技術の急速な発展に伴い、上海力程と科学研究ユニットによって開発された出張配信システムは、独立した知的財産権を備えた高度な技術を使用して、便利で迅速な合理化されたプロジェクトで世界の人々の生活のあらゆる側面にサービスを提供し、誰もがインターネット上で生活できるようにします 社会の普通の人々は、インターネット経済の揺らぎになる機会があります。 中国国家の優れた伝統文化と現代の民主的なライフスタイルの完璧な統合を毎秒オンラインライフ体験に感じさせ、真のヒューマニスティックケアと物質的な生活の継続的な充実と改善を感じさせ、ネットワーク社会を促進します リチェンの人々のすべての熱意と知恵に捧げられた、健康的で調和のとれた安定した開発！2016年は、リチェンがより高い開発の到来を告げる時期です。革新と進歩を原動力として、開発のスピードをさらに加速し、開発の質を向上させ、国内外の航空券を販売します。 本体と休暇の予約を同時に行い、包括的な開発戦略を実施し、情報化の促進と情報プラットフォームの構築に重点を置きます。',
    ManagementTeam:'緊密で洗練された管理チーム',
    ManagementTeamContent:'上海の管理チームのリソース協力、管理スキル、ビジネス経験の完璧な組み合わせ、およびチーム間の緊密な協力により、会社の迅速かつ着実な発展が保証されます。 当社の上級管理チームは、国際IT業界、観光、金融業界での事業運営と管理における長年の経験を集めています。中間管理チームは、中国のIT業界、航空代理店業界、観光業界を結集し、サービスとリソースの規模を確保しています。 管理ポリシー。',
    TechnicalService:'テクノロジーのリーダーシップとサービス',
    TechnicalServiceContent:'力程は常に技術革新を会社の活力の源泉と見なしており、R＆D機能の強化に努力を惜しみませんでした。 力程は、国際および国内の航空券の販売を本体として、ホテルの予約と休暇の予約を同時に行い、包括的な開発戦略を実施し、情報の促進に重点を置いて、開発のスピードをさらに加速し、開発の品質を向上させるために、革新と進取の気性に基づく最新のサービスシステムの完全なセットを確立しました そして、情報プラットフォームを構築します。',
    AboutUsContent:'電話：400-088-8020',
  },
  share: {
    hot:'人気',
    calendarDataTitle:'日付を選択',
    calendarDataExplain:'照会日は出発日です',
    cancelTxt:'キャンセル',
    confirmTxt:'決定する',
    pullUpLoadMoreTxt:'もっと読み込む',
    pullUpLoadNoMoreTxt:'これ以上',
    RefreshTheSuccess:'リフレッシュ成功',
    Save:'セーブ',
    Add:'追加',
    QueryBtn:'検索',
    SubmitBtn:'提出',
    AmendBtn:'修正',
    FinishBtn:'完成',
    fail: {
      CancelOrder:'キャンセルしたいの注文を選択してください',
      RefundOrder:'キャンセルしたいの払い戻し注文を選択してください',
      selectTraveller:'乗客を選択してください！',
      minPrice:'お勧めのフライトやクラスではありませんが、予約を続行してもよろしいですか？',
      CostCenter:'コストセンターを入力してください！',
      TravelPurpose:'旅行の目的を入力してください！',
      EnglishName:'乗客には英語の名前がありません！',
      RefundJourney:'払い戻しに必要のある旅程を選択してください！',
      RefundReason:'キャンセルの理由を選択してください！',
      RefundTraveller:'払い戻しに必要な乗客を選択してください！',
      ChangeJourney:'変更する必要のある旅程を選択してください！',
      ChangeTraveller:'変更する必要のある乗客を選択してください！',
      ChooseAnotherFlight:'他の航空会社のフライトを選択してください！',
      TheCorrectName:'正しい姓名を入力してください！',
      UsreNameRepetition:'乗客名を繰り返すことはできません！',
      RegisterPhone:'携帯電話番号を登録またはバインドしてください！',
      VerificationCode:'確認コードを入力してください',
      DynamicCode:'動的コードを入力してください',
      PassengerSurname:'乗客の姓を入力してください',
      PassengerName:'乗客名を入力してください',
      RefusalCause:'拒否の理由を記入してください！',
      PhoneBinding:'バインドされた携帯電話番号を空にすることはできません',
      EmailBinding:'バインドされたメールボックスを空にすることはできません',
      Phone:'有効な電話番号を入力して下さい',
      Email:'有効なメールアドレスを入力してください',
      VerificationTime:'確認コードは60秒ごとに取得できます',
      Account:'ユーザー名を入力してください',
      AccountEmpty:'アカウントを空にすることはできません',
      PasswordEmpty:'パスワードを空白にすることはできません',
      PassengersNumbers:'乗客数に上限がありますので、カスタマーサービスまでご連絡ください',
      ManyPeople:'人数が多すぎる場合は、カスタマーサービスまでご連絡ください。',
      ChangeReason:'変更理由を空にすることはできません',
      SeatNumbers:'乗客数が選択した座席数を超えている',
      SelectSeat:'選択した乗客の座席を選択してください',
    },
    succ: {
      SaveSucc:'正常に保存！',
      CancelSucc:'成功をキャンセルします！',
      ApprovalRefused:'承認が拒否されました！',
      ApproveSucc:'承認されました！',
      RefundSucc:'払い戻し申請が正常に送信されました',
      ChangeSucc:'変更申請は正常に送信されました。',
      RegisteredSucc:'登録完了！',
      LoginSucc:'ログイン成功！',
      ChangePasswordSucc:'パスワードのリセットが完了しました',
      VerificationSucc:'確認コードが正常に送信されました',
      AddSucc:'正常に追加されました',
      ModifySucc:'正常に変更されました',
      DeleteSucc:'正常に削除されました',
      WeChat:'WeChatは正常にバインド解除されます',
    },
    confirm: {
      YesOrNoDelect:'削除の確認しますか？',
      CreateOrder:'注文は正常に作成されました。いつでも注文の詳細で注文の進行状況を確認できます。',
      ThankRemarks:'力程ビジネストラベルに対する長年の信頼とサポートに感謝します。ユーザーの旅行体験を向上させるために、力程ビジネストラベルは2018年10月30日の午前9時から力程ビジネストラベルl2.0システムを正式にリリースしました。 ユーザーはAppStoreからAndroidシステムを自動的に更新できます。緊急電話番号15901610043については、当社のカスタマーサービスにお問い合わせください。 ありがとうございました！',
    },
    loading: {
      load:'ロードしようとしています',
      creatOrder:'注文が作成しています',
      PriceCalculation:'価格計算中',
    },
  },
  Categorys: {
    Young:'大人',
    Enfant:'小児',
    Infant:'乳児',
    economyClass:'エコノミークラス',
    buissenesClass:'ビジネスクラス',
    firstClass:'ファーストクラス',
    OnBusiness:'公務出張',
    OnPersonal:'個人予約',
    FlightService:'航空券',
    HotelService:'ホテル',
    TourService:'旅行',
    TrainService:'列車',
    SingleVoyage:'片道',
    RoundVoyage:'往復',
    WaitBooking:'予約待ち',
    WaitConfirm:'確認待ち',
    WaitPayment:'支払い待ち',
    WaitDispose:'処理待ち',
    Finished:'完成しました',
    Canceled:'キャンセルしました',
    Rejected:'拒否しました',
    Cannot:'一時処理できない',
    WaitApprove:'承認待ち',
    Discrete:'スプリット',
    WaitSubmit:'提出待ち',
    WaitRefund:'払い戻し待ち',
    Male:'男',
    Female:'女',
    IDCard:'IDカード',
    PassportCard:'パスポート',
    StudentCard:'学生証',
    OfficerCard:'士官証明書',
    HKMpermit:'香港とマカオパス',
    TaiWpermit:'台湾パス',
    OtherCard:'その他',
    Company:'会社',
    User:'ユーザー',
    HotelFare:'室料',
    TicketFare:'票面',
    MobileAuth:'電話アカウント',
    EmailAuth:'電子メールアドレス',
    AccountAuth:'アカウントパスワード',
    WeixinAuth:'WeChat認証',
    DynamicAuth:'動的パスワード',
    MessageNotify:'SMS通知',
    MailNotify:'電子メール通知',
    WechatNotify:'WeChat通知',
    AppNotify:'アプリ通知',
    Normal:'普通',
    OverseasStudent:'学生',
    Worker:'労務',
    Immigrant:'新しい移民',
    '1138Categorys': 'IDカード',
    '1139Categorys': 'パスポート',
    '1140Categorys': '学生証',
    '1141Categorys': '士官証明書',
    '1298Categorys': '香港とマカオパス',
    '1299Categorys': '台湾パス',
    '1142Categorys': 'その他',
    AmendingFlight:'一部払い戻し中',
    ChangeingFlight:'一部変更中',
    AmendingTrain:'一部払い戻し中',
    ChangeingTrain:'一部変更中',
    AmendingHotel:'一部チェックアウト中',
    ChangeingHotel:'一部変更中',
    AmendingTour:'一部グループから離脱中',
    ChangeingTour:'一部変更中',
    AmendedFlight:'一部払い戻し',
    ChangeedFlight:'一部変更',
    AmendedTrain:'一部払い戻し',
    ChangeedTrain:'一部変更',
    AmendedHotel:'一部チェックアウト',
    ChangeedHotel:'一部変更',
    AmendedTour:'一部グループから離脱',
    ChangeedTour:'一部変更',
    AllAmendingFlight:'払い戻し中',
    AllChangeingFlight:'変更中',
    AllBookingFlight:'発券中',
    AllAmendingTrain:'払い戻し中',
    AllChangeingTrain:'変更中',
    AllBookingTrain:'発券中',
    AllAmendingHotel:'チェックアウト中',
    AllChangeingHotel:'変更中',
    AllBookingHotel:'予約中',
    AllAmendingTour:'グループから離脱中',
    AllChangeingTour:'変更中',
    AllBookingTour:'予約中',
    AllAmendedFlight:'払い戻し成功',
    AllChangeedFlight:'変更成功',
    AllBookedFlight:'発券成功',
    AllAmendedTrain:'払い戻し成功',
    AllChangeedTrain:'変更成功',
    AllBookedTrain:'発券成功',
    AllAmendedHotel:'チェックアウト成功',
    AllChangeedHotel:'変更成功',
    AllBookedHotel:'予約成功',
    AllAmendedTour:'グループから離脱完成',
    AllChangeedTour:'変更成功',
    AllBookedTour:'予約成功',


  },
  RegExp: {
    AccountReg: {
      isEmpty:'アカウントを空にすることはできません',
      isFormat:'アカウント形式が正しくありません',
    },
    PwdReg: {
      isEmpty:'パスワードを空にすることはできません',
      isFormat:'パスワードの形式が正しくありません',
    },
    ConfigPwd: {
      isEmpty:'パスワードを空にすることはできません',
      isFormat:'パスワード不一致',
    },
    VerificationCodeReg: {
      isEmpty: '確認コードを空にすることはできません',
    },
    DynamicCodeReg: {
      isEmpty: '動的コードを空にすることはできません',
    },
    ProtocolReg: {
      isFlag: '契約に準拠する必要があります'
    }
  }
}
